// import {
//   Category as CategoryIcon,
//   Close as CloseIcon,
//   Delete as DeleteIcon,
//   Description as DocumentIcon,
//   Edit as EditIcon,
//   ExpandLess,
//   ExpandMore,
//   FilterList as FilterIcon,
//   Folder as FolderIcon,
//   VisibilityOff as HideThumbnailsIcon,
//   Image as ImageIcon,
//   PictureAsPdf as PdfIcon,
//   Visibility as PreviewIcon,
//   ViewSidebar as ThumbnailsIcon,
//   AccessTime as TimeIcon
// } from '@mui/icons-material';
// import {
//   Alert,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Collapse,
//   Container,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   Fab,
//   Grid,
//   IconButton,
//   Menu,
//   MenuItem,
//   Paper,
//   Stack,
//   Tooltip,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { blue, grey, purple, red, green } from '@mui/material/colors';
// import { useAppSelector } from 'app/hooks';
// import { AppDispatch, RootState } from 'app/store';
// import ConfirmationDialog from 'commonComponents/ConfirmationDialog';
// import { useWindowSize } from 'hooks/useWindowSize';
// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'react-pdf/dist/Page/TextLayer.css';
// import { useDispatch, useSelector } from 'react-redux';
// import axiosInstance from 'Services/APIService';
// import {
//   clearTemplateError,
//   deleteTemplateById,
//   getTemplateById,
//   listTemplates
// } from 'slices/payrolslices/documentTemplateSlice';
// import {
//   buttonStyles,
//   getCategoryColor,
//   getCategoryIcon,
//   typography
// } from './documentHelper/DocumentHelperFunctions';
// import { useDocumentManagement } from './DocumentManagementContext';
// import { CategoryData, Template } from './types';
// import ViewInputFieldOverlay from './viewTempletsList/ViewInputFieldOverlay';

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// // Interfaces for nested structure

// const iconButtonStyles = {
//   base: {
//     borderRadius: 1.5,
//     transition: 'all 0.2s ease'
//   },
//   sizes: {
//     small: {
//       width: 24,
//       height: 24
//     },
//     medium: {
//       width: 28,
//       height: 28
//     }
//   }
// };

// const ViewTemplatesListComponent: React.FC = () => {
//   const { openCreatePage } = useDocumentManagement();
//   const dispatch = useDispatch<AppDispatch>();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const windowSize = useWindowSize();

//   // Redux state
//   const { loading, error, templates, categories, totalTemplates } = useSelector(
//     (state: RootState) => state.documentTemplate
//   );

//   console.log('Templates from Redux:', templates);

//   // Local state
//   const [displayTemplates, setDisplayTemplates] = useState<Template[]>([]);
//   const [filteredTemplates, setFilteredTemplates] = useState<Template[]>([]);
//   const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
//   const [previewModalOpen, setPreviewModalOpen] = useState(false);
//   const [pdfNumPages, setPdfNumPages] = useState<number>(0);
//   const [currentPdfPage, setCurrentPdfPage] = useState<number>(1);
//   const [templatePreviewUrl, setTemplatePreviewUrl] = useState<string | null>(null);
//   const [previewLoading, setPreviewLoading] = useState(false);
//   const [cardPreviewUrls, setCardPreviewUrls] = useState<{ [key: string]: string }>({});

//   // Confirmation dialog state
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [templateToDelete, setTemplateToDelete] = useState<Template | null>(null);
//   const [deleteLoading, setDeleteLoading] = useState(false);

//   // Thumbnail sidebar state
//   const [showThumbnails, setShowThumbnails] = useState(true);
//   const [thumbnailsLoaded, setThumbnailsLoaded] = useState<Set<number>>(new Set());

//   // NEW: Category and subcategory state for nested structure
//   const [selectedCategory, setSelectedCategory] = useState<string>('');
//   const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');
//   const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());
//   const [categoryData, setCategoryData] = useState<CategoryData[]>([]);

//   // Mobile category menu
//   const [categoryMenuAnchor, setCategoryMenuAnchor] = useState<null | HTMLElement>(null);
//   const categoryMenuOpen = Boolean(categoryMenuAnchor);

//   // PDF container ref for coordinate calculations
//   const pdfContainerRef = useRef<HTMLDivElement>(null);
//   const [overlayRenderTrigger, setOverlayRenderTrigger] = useState(0);

//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
//   const selectedServiceTitle = useAppSelector(
//     (state) => state.serviceSelected.selectedServiceTitle
//   );

//   // Calculate PDF width dynamically
//   const calculatePdfWidth = () => {
//     const sidebarWidth = showThumbnails && pdfNumPages > 1 ? 120 : 0;
//     const padding = isMobile ? 32 : 48;
//     const toolbarWidth = 100;
//     const availableWidth = windowSize.width - sidebarWidth - padding - toolbarWidth;

//     return Math.max(Math.min(availableWidth, isMobile ? 350 : 700), 280);
//   };

//   // Field click handler for template view
//   const handleFieldClick = useCallback((field: any) => {
//     console.log('Template field clicked:', field);
//   }, []);

//   // Confirmation dialog helper functions
//   const getDialogTitle = () => 'Confirm Delete Template';
//   const getDialogMessage = () =>
//     templateToDelete
//       ? `Are you sure you want to <strong>delete</strong> the template "<strong>${templateToDelete.documentName}</strong>"? This action cannot be undone.`
//       : '';
//   const getDialogButtonText = () => 'Delete Template';
//   const getDialogButtonColor = (): 'primary' | 'error' | 'success' => 'error';

//   // Delete handlers
//   const handleOpenDeleteConfirmation = (template: Template) => {
//     setTemplateToDelete(template);
//     setConfirmDialogOpen(true);
//   };

//   const handleCloseDeleteConfirmation = () => {
//     setConfirmDialogOpen(false);
//     setTemplateToDelete(null);
//   };

//   const handleConfirmDelete = async () => {
//     if (!templateToDelete || !selectedProjectId || !selectedServiceTitle) return;

//     setDeleteLoading(true);
//     try {
//       await dispatch(
//         deleteTemplateById({
//           group_id: selectedProjectId,
//           service_id: selectedServiceTitle,
//           category: templateToDelete.category,
//           document_id: templateToDelete.documentId
//         })
//       ).unwrap();

//       await dispatch(
//         listTemplates({
//           group_id: selectedProjectId,
//           service_id: selectedServiceTitle,
//           category_id: null
//         })
//       ).unwrap();

//       handleCloseDeleteConfirmation();
//     } catch (error) {
//       console.error('Error deleting template:', error);
//     } finally {
//       setDeleteLoading(false);
//     }
//   };

//   // Trigger overlay re-render when PDF loads/scales
//   useEffect(() => {
//     if (templatePreviewUrl && pdfNumPages > 0) {
//       const timer = setTimeout(() => {
//         setOverlayRenderTrigger((prev) => prev + 1);
//       }, 300);
//       return () => clearTimeout(timer);
//     }
//   }, [templatePreviewUrl, pdfNumPages, currentPdfPage]);

//   // Load templates on component mount
//   useEffect(() => {
//     const loadTemplates = async () => {
//       if (selectedProjectId && selectedServiceTitle) {
//         try {
//           await dispatch(
//             listTemplates({
//               group_id: selectedProjectId,
//               service_id: selectedServiceTitle,
//               category_id: null
//             })
//           ).unwrap();
//         } catch (error) {
//           console.error('Failed to load templates:', error);
//         }
//       }
//     };

//     loadTemplates();
//   }, [dispatch, selectedProjectId, selectedServiceTitle]);

//   // FIXED: Process nested category-subcategory structure with proper initialization
//   // In your component's useEffect - FIXED
//   useEffect(() => {
//     let templatesData: Template[] = [];
//     let processedCategoryData: CategoryData[] = [];

//     console.log('Redux templates:', templates);
//     console.log('Redux categories:', categories);

//     if (templates && templates.length > 0) {
//       templatesData = templates.filter((template) => template && template.documentId);
//     }

//     if (categories && categories.length > 0) {
//       // Categories are now properly formatted as CategoryData[]
//       // Extract nested structure from templates for UI display
//       processedCategoryData = categories.map((category) => {
//         const categoryTemplates = templatesData.filter((t) => t.category === category.category);

//         // Group templates by subcategory
//         const subcategoriesMap = new Map();
//         categoryTemplates.forEach((template) => {
//           const subcategory = template.subcategory || 'General';
//           if (!subcategoriesMap.has(subcategory)) {
//             subcategoriesMap.set(subcategory, {
//               subcategoryId: `${category.category}-${subcategory}`
//                 .toLowerCase()
//                 .replace(/\s+/g, '-'),
//               subcategory: subcategory,
//               templates: [],
//               count: 0
//             });
//           }
//           subcategoriesMap.get(subcategory).templates.push(template);
//           subcategoriesMap.get(subcategory).count++;
//         });

//         return {
//           categoryId: `cat-${category.category}`.toLowerCase().replace(/\s+/g, '-'),
//           category: category.category,
//           subcategories: Array.from(subcategoriesMap.values()),
//           totalTemplates: categoryTemplates.length
//         };
//       });
//     }

//     console.log('Processed templates data:', templatesData);
//     console.log('Processed category data:', processedCategoryData);

//     setDisplayTemplates(templatesData);
//     setCategoryData(processedCategoryData);

//     // Auto-expand first category and select first subcategory
//     if (processedCategoryData.length > 0 && !selectedCategory) {
//       const firstCategory = processedCategoryData[0];
//       if (firstCategory && firstCategory.category) {
//         setSelectedCategory(firstCategory.category);
//         setExpandedCategories(new Set([firstCategory.category]));

//         if (
//           firstCategory.subcategories &&
//           firstCategory.subcategories.length > 0 &&
//           !selectedSubcategory
//         ) {
//           const firstSubcategory = firstCategory.subcategories[0];
//           if (firstSubcategory && firstSubcategory.subcategory) {
//             setSelectedSubcategory(firstSubcategory.subcategory);
//           }
//         }
//       }
//     }
//   }, [templates, categories, loading]);

//   // FIXED: Load card previews with null checks
//   useEffect(() => {
//     const fetchCardPreviews = async () => {
//       const newPreviewUrls: { [key: string]: string } = {};

//       if (!displayTemplates || displayTemplates.length === 0) return;

//       for (const template of displayTemplates) {
//         if (!template || !template.documentId || !template.uploadedFile?.storedFilePath) {
//           continue;
//         }

//         try {
//           const encodedPath = encodeURIComponent(template.uploadedFile.storedFilePath);
//           const response = await axiosInstance.get(`/avatar/get-avatar?path=${encodedPath}`, {
//             responseType: 'blob'
//           });

//           if (template.uploadedFile.fileType === 'pdf') {
//             const pdfBlobUrl = URL.createObjectURL(response.data);
//             newPreviewUrls[template.documentId] = pdfBlobUrl;
//           } else {
//             const imageUrl = URL.createObjectURL(response.data);
//             newPreviewUrls[template.documentId] = imageUrl;
//           }
//         } catch (error) {
//           console.error(`Error fetching card preview for ${template.documentName}:`, error);
//         }
//       }

//       setCardPreviewUrls(newPreviewUrls);
//     };

//     if (displayTemplates && displayTemplates.length > 0) {
//       fetchCardPreviews();
//     }

//     return () => {
//       Object.values(cardPreviewUrls).forEach((url) => {
//         if (url) {
//           URL.revokeObjectURL(url);
//         }
//       });
//     };
//   }, [displayTemplates]);

//   // UPDATED: Filter templates by selected category and subcategory
//   useEffect(() => {
//     if (!displayTemplates) {
//       setFilteredTemplates([]);
//       return;
//     }

//     console.log('Filtering templates with:', displayTemplates);

//     let filtered = displayTemplates.filter((template) => template && template.documentId);

//     if (selectedCategory) {
//       filtered = filtered.filter((template) => template.category === selectedCategory);
//     }

//     if (selectedSubcategory) {
//       filtered = filtered.filter((template) => template.subcategory === selectedSubcategory);
//     }

//     setFilteredTemplates(filtered);
//   }, [selectedCategory, selectedSubcategory, displayTemplates]);

//   // Fetch template preview for modal
//   const fetchTemplatePreview = async (template: Template) => {
//     if (!template?.uploadedFile?.storedFilePath) {
//       return null;
//     }

//     try {
//       setPreviewLoading(true);
//       const encodedPath = encodeURIComponent(template.uploadedFile.storedFilePath);
//       const response = await axiosInstance.get(`/avatar/get-avatar?path=${encodedPath}`, {
//         responseType: 'blob'
//       });

//       const blobUrl = URL.createObjectURL(response.data);
//       setTemplatePreviewUrl(blobUrl);
//       return blobUrl;
//     } catch (error) {
//       console.error('Error fetching template preview:', error);
//       return null;
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   const getFileTypeIcon = (fileName: string) => {
//     const extension = fileName?.split('.').pop()?.toLowerCase();
//     const iconSize = isMobile ? 32 : 48;

//     switch (extension) {
//       case 'pdf':
//         return <PdfIcon sx={{ fontSize: iconSize, color: red[500] }} />;
//       case 'jpg':
//       case 'jpeg':
//       case 'png':
//       case 'gif':
//         return <ImageIcon sx={{ fontSize: iconSize, color: blue[500] }} />;
//       default:
//         return <DocumentIcon sx={{ fontSize: iconSize, color: grey[500] }} />;
//     }
//   };

//   const formatDate = (dateString: string) => {
//     try {
//       return new Date(dateString).toLocaleDateString('en-US', {
//         month: 'short',
//         day: 'numeric'
//       });
//     } catch {
//       return dateString;
//     }
//   };

//   // Handle category expansion/collapse
//   const handleCategoryToggle = (categoryName: string) => {
//     const newExpanded = new Set(expandedCategories);
//     if (newExpanded.has(categoryName)) {
//       newExpanded.delete(categoryName);
//     } else {
//       newExpanded.add(categoryName);
//     }
//     setExpandedCategories(newExpanded);
//   };

//   // Handle subcategory selection
//   const handleSubcategorySelect = (categoryName: string, subcategoryName: string) => {
//     setSelectedCategory(categoryName);
//     setSelectedSubcategory(subcategoryName);
//     setCategoryMenuAnchor(null);
//   };

//   const handleTemplateClick = async (template: Template) => {
//     if (!template || !template.documentId) return;

//     setSelectedTemplate(template);
//     setPreviewModalOpen(true);
//     setCurrentPdfPage(1);
//     setThumbnailsLoaded(new Set());
//     setOverlayRenderTrigger(0);

//     if (selectedProjectId && selectedServiceTitle) {
//       try {
//         const response = await dispatch(
//           getTemplateById({
//             group_id: selectedProjectId,
//             service_id: selectedServiceTitle,
//             category: template.category,
//             document_id: template.documentId,
//             category_id: template.categoryId
//           })
//         ).unwrap();

//         let fullTemplate: Template;
//         if ('template' in response && response.template) {
//           fullTemplate = response.template as Template;
//         } else {
//           fullTemplate = response as Template;
//         }

//         setSelectedTemplate(fullTemplate);
//         await fetchTemplatePreview(fullTemplate);
//       } catch (error) {
//         console.error('Error fetching template details:', error);
//         await fetchTemplatePreview(template);
//       }
//     }
//   };

//   const handleClosePreview = () => {
//     setPreviewModalOpen(false);
//     setSelectedTemplate(null);
//     setThumbnailsLoaded(new Set());
//     setOverlayRenderTrigger(0);
//     if (templatePreviewUrl) {
//       URL.revokeObjectURL(templatePreviewUrl);
//       setTemplatePreviewUrl(null);
//     }
//     setPdfNumPages(0);
//   };

//   const handleEdit = (e: React.MouseEvent, template: Template) => {
//     e.stopPropagation();
//     if (template && template.documentId) {
//       openCreatePage(template.documentId, template.documentName, template.categoryId, template);
//     }
//   };

//   const handleDelete = async (e: React.MouseEvent, template: Template) => {
//     e.stopPropagation();
//     if (template && template.documentId) {
//       handleOpenDeleteConfirmation(template);
//     }
//   };

//   const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
//     setPdfNumPages(numPages);
//     setTimeout(() => {
//       setOverlayRenderTrigger((prev) => prev + 1);
//     }, 100);
//   };

//   const onDocumentLoadError = (error: Error) => {
//     console.error('PDF load error:', error);
//   };

//   // Enhanced thumbnail rendering
//   const renderThumbnail = (pageNumber: number) => {
//     const isSelected = currentPdfPage === pageNumber;
//     const fieldsOnPage =
//       selectedTemplate?.inputFields?.filter((field) => field.pageNumber === pageNumber) ?? [];

//     return (
//       <Box
//         key={`thumbnail-${pageNumber}`}
//         onClick={() => setCurrentPdfPage(pageNumber)}
//         sx={{
//           position: 'relative',
//           cursor: 'pointer',
//           border: isSelected ? '2px solid #1976d2' : '1px solid #ddd',
//           borderRadius: 1,
//           bgcolor: isSelected ? '#e3f2fd' : 'white',
//           overflow: 'hidden',
//           transition: 'all 0.2s ease',
//           '&:hover': {
//             borderColor: '#1976d2',
//             transform: 'scale(1.02)',
//             boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//           },
//           width: isMobile ? 60 : 80,
//           height: isMobile ? 84 : 112,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           mx: 'auto',
//           mb: 1,
//           flexShrink: 0
//         }}
//       >
//         <Document file={templatePreviewUrl} loading={null} error={null}>
//           <Page
//             pageNumber={pageNumber}
//             width={isMobile ? 50 : 70}
//             height={isMobile ? 70 : 98}
//             renderTextLayer={false}
//             renderAnnotationLayer={false}
//             loading={
//               <Box
//                 sx={{
//                   width: isMobile ? 50 : 70,
//                   height: isMobile ? 70 : 98,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   bgcolor: grey[50]
//                 }}
//               >
//                 <CircularProgress size={16} />
//               </Box>
//             }
//             onRenderSuccess={() => {
//               setThumbnailsLoaded((prev) => new Set([...Array.from(prev), pageNumber]));
//             }}
//           />
//         </Document>

//         <Box
//           sx={{
//             position: 'absolute',
//             bottom: 2,
//             left: 2,
//             bgcolor: isSelected ? '#1976d2' : 'rgba(0,0,0,0.7)',
//             color: 'white',
//             px: 0.5,
//             py: 0.25,
//             borderRadius: 0.5,
//             fontSize: isMobile ? '8px' : '10px',
//             fontWeight: 600,
//             lineHeight: 1,
//             minWidth: 16,
//             textAlign: 'center'
//           }}
//         >
//           {pageNumber}
//         </Box>

//         {fieldsOnPage.length > 0 && (
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 2,
//               right: 2,
//               bgcolor: '#ff9800',
//               color: 'white',
//               minWidth: 16,
//               height: 16,
//               borderRadius: '50%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: isMobile ? '8px' : '9px',
//               fontWeight: 600,
//               lineHeight: 1
//             }}
//           >
//             {fieldsOnPage.length}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   // PDF preview with thumbnails
//   const renderPdfPreviewWithThumbnails = () => (
//     <Box
//       sx={{
//         display: 'flex',
//         height: '65vh',
//         border: `1px solid ${theme.palette.divider}`,
//         borderRadius: 1.5,
//         overflow: 'hidden',
//         position: 'relative'
//       }}
//     >
//       {/* Thumbnails Sidebar */}
//       {showThumbnails && pdfNumPages > 1 && (
//         <Box
//           sx={{
//             width: isMobile ? 100 : 120,
//             minWidth: isMobile ? 100 : 120,
//             borderRight: '1px solid #e0e0e0',
//             bgcolor: '#fafafa',
//             overflowY: 'auto',
//             overflowX: 'hidden',
//             height: '100%',
//             display: 'flex',
//             flexDirection: 'column',
//             gap: 1,
//             p: 1,
//             position: 'relative',
//             zIndex: theme.zIndex.drawer,
//             '::-webkit-scrollbar': { width: '6px' },
//             '::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '3px' },
//             '::-webkit-scrollbar-thumb': {
//               background: '#c1c1c1',
//               borderRadius: '3px',
//               '&:hover': { background: '#a8a8a8' }
//             },
//             scrollbarWidth: 'thin',
//             scrollbarColor: '#c1c1c1 #f1f1f1'
//           }}
//         >
//           <Typography
//             variant="caption"
//             sx={{
//               fontSize: isMobile ? '8px' : '10px',
//               fontWeight: 600,
//               textAlign: 'center',
//               color: '#666',
//               mb: 0.5
//             }}
//           >
//             Pages ({pdfNumPages})
//           </Typography>

//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               gap: 0.5,
//               width: '100%',
//               alignItems: 'center'
//             }}
//           >
//             {Array.from(new Array(pdfNumPages), (_, index) => renderThumbnail(index + 1))}
//           </Box>
//         </Box>
//       )}

//       {/* Main PDF Viewer */}
//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           minWidth: 0,
//           position: 'relative',
//           zIndex: 1
//         }}
//       >
//         {/* PDF Toolbar */}
//         <Box
//           sx={{
//             borderBottom: `1px solid ${theme.palette.divider}`,
//             p: 1,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             bgcolor: grey[50],
//             flexShrink: 0,
//             zIndex: 2
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             {pdfNumPages > 1 && (
//               <Tooltip title={showThumbnails ? 'Hide Thumbnails' : 'Show Thumbnails'}>
//                 <IconButton
//                   onClick={() => setShowThumbnails(!showThumbnails)}
//                   size="small"
//                   sx={{
//                     bgcolor: 'white',
//                     border: '1px solid #e0e0e0',
//                     '&:hover': { bgcolor: grey[100] }
//                   }}
//                 >
//                   {showThumbnails ? <HideThumbnailsIcon /> : <ThumbnailsIcon />}
//                 </IconButton>
//               </Tooltip>
//             )}

//             <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//               Page {currentPdfPage} of {pdfNumPages}
//             </Typography>
//           </Box>

//           {pdfNumPages > 1 && (
//             <Box sx={{ display: 'flex', gap: 0.5 }}>
//               <Button
//                 onClick={() => setCurrentPdfPage(Math.max(1, currentPdfPage - 1))}
//                 disabled={currentPdfPage <= 1}
//                 size="small"
//                 sx={{
//                   ...buttonStyles.base,
//                   ...buttonStyles.sizes.small,
//                   ...buttonStyles.variants.outlined,
//                   minWidth: 40
//                 }}
//               >
//                 ←
//               </Button>
//               <Button
//                 onClick={() => setCurrentPdfPage(Math.min(pdfNumPages, currentPdfPage + 1))}
//                 disabled={currentPdfPage >= pdfNumPages}
//                 size="small"
//                 sx={{
//                   ...buttonStyles.base,
//                   ...buttonStyles.sizes.small,
//                   ...buttonStyles.variants.outlined,
//                   minWidth: 40
//                 }}
//               >
//                 →
//               </Button>
//             </Box>
//           )}
//         </Box>

//         {/* Main PDF Display Area */}
//         <Box
//           ref={pdfContainerRef}
//           sx={{
//             flex: 1,
//             overflowY: 'auto',
//             overflowX: 'auto',
//             p: 2,
//             bgcolor: grey[50],
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'flex-start',
//             minHeight: 0,
//             position: 'relative',
//             zIndex: 1
//           }}
//         >
//           <Box
//             sx={{
//               position: 'relative',
//               maxWidth: '100%',
//               maxHeight: '100%',
//               isolation: 'isolate'
//             }}
//           >
//             <Document
//               file={templatePreviewUrl}
//               onLoadSuccess={onDocumentLoadSuccess}
//               onLoadError={onDocumentLoadError}
//               loading={
//                 <Box sx={{ p: 4, textAlign: 'center' }}>
//                   <CircularProgress size={24} />
//                   <Typography sx={{ mt: 1 }}>Loading PDF...</Typography>
//                 </Box>
//               }
//               error={
//                 <Box sx={{ p: 4, textAlign: 'center' }}>
//                   <Typography color="error">Failed to load PDF. Please try again.</Typography>
//                 </Box>
//               }
//             >
//               <Page
//                 pageNumber={currentPdfPage}
//                 width={calculatePdfWidth()}
//                 renderTextLayer={false}
//                 renderAnnotationLayer={false}
//                 loading={<CircularProgress size={20} />}
//                 onRenderSuccess={() => {
//                   setTimeout(() => {
//                     setOverlayRenderTrigger((prev) => prev + 1);
//                   }, 100);
//                 }}
//               />
//             </Document>

//             {/* Field overlays */}
//             {selectedTemplate?.inputFields
//               ?.filter((field: any) => field.pageNumber === currentPdfPage)
//               .map((field: any) => (
//                 <ViewInputFieldOverlay
//                   key={field.id}
//                   field={field}
//                   pdfContainerRef={pdfContainerRef}
//                   handleFieldClick={handleFieldClick}
//                   isMobile={isMobile}
//                   isTemplateView={true}
//                 />
//               ))}
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );

//   // FIXED: Template preview render function with null checks
//   const renderTemplatePreview = (template: Template) => {
//     // Add comprehensive null checks
//     if (!template || !template.documentId) return null;

//     const previewUrl = cardPreviewUrls[template.documentId];

//     return (
//       <Box
//         sx={{
//           height: '100%',
//           width: '100%',
//           bgcolor: '#f8f9fa',
//           borderRadius: 1.5,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           position: 'relative',
//           cursor: 'pointer',
//           overflow: 'hidden',
//           border: `2px solid ${grey[200]}`,
//           '&:hover': {
//             bgcolor: '#e9ecef',
//             borderColor: theme.palette.primary.main,
//             '& .preview-overlay': {
//               opacity: 1
//             }
//           }
//         }}
//         onClick={() => handleTemplateClick(template)}
//       >
//         {previewUrl ? (
//           template.uploadedFile?.fileType === 'pdf' ? (
//             <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
//               <Document
//                 file={previewUrl}
//                 loading={
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       height: '100%'
//                     }}
//                   >
//                     <CircularProgress size={16} />
//                   </Box>
//                 }
//                 error={
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       height: '100%'
//                     }}
//                   >
//                     <PdfIcon sx={{ fontSize: 32, color: red[500], opacity: 0.6 }} />
//                     <Typography sx={{ ...typography.smallText, color: grey[600] }}>PDF</Typography>
//                   </Box>
//                 }
//                 noData={
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       height: '100%'
//                     }}
//                   >
//                     <PdfIcon sx={{ fontSize: 32, color: red[500], opacity: 0.6 }} />
//                     <Typography sx={{ ...typography.smallText, color: grey[600] }}>PDF</Typography>
//                   </Box>
//                 }
//               >
//                 <Page
//                   pageNumber={1}
//                   width={120}
//                   renderTextLayer={false}
//                   renderAnnotationLayer={false}
//                   loading={<CircularProgress size={12} />}
//                 />
//               </Document>
//             </Box>
//           ) : (
//             <img
//               src={previewUrl}
//               alt={template.documentName || 'Template'}
//               style={{
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',
//                 borderRadius: '8px'
//               }}
//             />
//           )
//         ) : (
//           <Box
//             sx={{
//               opacity: 0.6,
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               gap: 0.5
//             }}
//           >
//             {getFileTypeIcon(template.uploadedFile?.fileName || 'document')}
//             <Typography sx={{ ...typography.smallText, color: grey[600], textAlign: 'center' }}>
//               {template.uploadedFile?.fileType?.toUpperCase() || 'FILE'}
//             </Typography>
//           </Box>
//         )}

//         <Box
//           className="preview-overlay"
//           sx={{
//             position: 'absolute',
//             inset: 0,
//             bgcolor: 'rgba(0, 0, 0, 0.8)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             opacity: 0,
//             transition: 'opacity 0.3s ease'
//           }}
//         >
//           <Box sx={{ textAlign: 'center', color: 'white' }}>
//             <PreviewIcon sx={{ fontSize: isMobile ? 24 : 32, mb: 0.5 }} />
//             <Typography sx={{ ...typography.smallText }}>Click to Preview</Typography>
//           </Box>
//         </Box>

//         {template.uploadedFile?.fileSize && (
//           <Chip
//             label={`${
//               template.uploadedFile.fileSize > 1024 * 1024
//                 ? `${(template.uploadedFile.fileSize / 1024 / 1024).toFixed(1)}MB`
//                 : `${(template.uploadedFile.fileSize / 1024).toFixed(0)}KB`
//             }`}
//             size="small"
//             sx={{
//               position: 'absolute',
//               top: 6,
//               right: 6,
//               fontSize: '0.5rem',
//               height: 16,
//               bgcolor: 'rgba(0, 0, 0, 0.7)',
//               color: 'white',
//               '& .MuiChip-label': { px: 0.5 }
//             }}
//           />
//         )}
//       </Box>
//     );
//   };

//   // Desktop category list with collapsible subcategories
//   const renderDesktopCategoryList = () => (
//     <Paper
//       elevation={0}
//       sx={{
//         height: 'calc(100vh - 160px)',
//         bgcolor: 'white',
//         border: `1px solid ${theme.palette.divider}`,
//         borderRadius: 1.5,
//         overflow: 'hidden'
//       }}
//     >
//       <Box sx={{ p: 1.5, pb: 1 }}>
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <CategoryIcon sx={{ color: purple[500], fontSize: 16 }} />
//           <Typography
//             sx={{
//               ...typography.sectionTitle,
//               fontWeight: 600
//             }}
//           >
//             Categories
//           </Typography>
//           <Chip
//             label={`${categoryData.length} Available`}
//             size="small"
//             sx={{
//               height: 20,
//               fontSize: '0.65rem',
//               bgcolor: `${purple[500]}15`,
//               color: purple[500]
//             }}
//           />
//         </Stack>
//       </Box>

//       <Divider sx={{ mx: 1.5, opacity: 0.6 }} />

//       <Box sx={{ p: 1, overflow: 'auto', height: 'calc(100% - 80px)' }}>
//         <Stack spacing={0.25}>
//           {categoryData.map((category) => {
//             if (!category || !category.category) return null;

//             const isExpanded = expandedCategories.has(category.category);
//             const categoryColor = getCategoryColor(category.category);

//             return (
//               <Box key={category.category}>
//                 {/* Main Category */}
//                 <Card
//                   sx={{
//                     p: 1,
//                     borderRadius: 1.5,
//                     boxShadow: 1,
//                     cursor: 'pointer',
//                     border: `1px solid ${theme.palette.divider}`,
//                     backgroundColor: 'background.paper',
//                     '&:hover': {
//                       boxShadow: 2,
//                       backgroundColor: `${categoryColor}08`,
//                       borderColor: categoryColor
//                     },
//                     transition: 'all 0.2s ease'
//                   }}
//                   onClick={() => handleCategoryToggle(category.category || '')}
//                 >
//                   <Stack direction="row" alignItems="center" spacing={1}>
//                     <Box
//                       sx={{
//                         width: 28,
//                         height: 28,
//                         borderRadius: 1,
//                         bgcolor: `${categoryColor}15`,
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         color: categoryColor
//                       }}
//                     >
//                       {React.cloneElement(getCategoryIcon(category.category), {
//                         style: { fontSize: 14 }
//                       })}
//                     </Box>
//                     <Box sx={{ flex: 1 }}>
//                       <Typography
//                         sx={{
//                           ...typography.bodyText,
//                           fontWeight: 600,
//                           lineHeight: 1.2
//                         }}
//                       >
//                         {category.category}
//                       </Typography>
//                     </Box>
//                     <Typography
//                       sx={{
//                         ...typography.smallText,
//                         color: categoryColor,
//                         bgcolor: `${categoryColor}15`,
//                         px: 0.75,
//                         py: 0.125,
//                         borderRadius: 0.75,
//                         minWidth: 16,
//                         textAlign: 'center'
//                       }}
//                     >
//                       {category.totalTemplates}
//                     </Typography>
//                     <IconButton size="small" sx={{ p: 0.25 }}>
//                       {isExpanded ? <ExpandLess /> : <ExpandMore />}
//                     </IconButton>
//                   </Stack>
//                 </Card>

//                 {/* Subcategories */}
//                 <Collapse in={isExpanded} timeout="auto" unmountOnExit>
//                   <Box sx={{ ml: 2, mt: 0.5 }}>
//                     <Stack spacing={0.25}>
//                       {category.subcategories?.map((subcategory) => {
//                         if (!subcategory || !subcategory.subcategory) return null;

//                         const isSelected =
//                           selectedCategory === category.category &&
//                           selectedSubcategory === subcategory.subcategory;

//                         return (
//                           <Card
//                             key={subcategory.subcategoryId}
//                             sx={{
//                               p: 0.75,
//                               borderRadius: 1,
//                               boxShadow: isSelected ? 2 : 0.5,
//                               cursor: 'pointer',
//                               border: isSelected
//                                 ? `2px solid ${green[500]}`
//                                 : `1px solid ${theme.palette.divider}`,
//                               backgroundColor: isSelected ? `${green[500]}08` : 'background.paper',
//                               '&:hover': {
//                                 boxShadow: 1,
//                                 backgroundColor: `${green[500]}08`,
//                                 borderColor: green[500]
//                               },
//                               transition: 'all 0.2s ease'
//                             }}
//                             onClick={() =>
//                               handleSubcategorySelect(
//                                 category.category || '',
//                                 subcategory.subcategory || ''
//                               )
//                             }
//                           >
//                             <Stack direction="row" alignItems="center" spacing={1}>
//                               <Box
//                                 sx={{
//                                   width: 4,
//                                   height: 16,
//                                   borderRadius: 2,
//                                   bgcolor: isSelected ? green[500] : grey[300]
//                                 }}
//                               />
//                               <Typography
//                                 sx={{
//                                   ...typography.smallText,
//                                   fontWeight: isSelected ? 600 : 400,
//                                   flex: 1
//                                 }}
//                               >
//                                 {subcategory.subcategory}
//                               </Typography>
//                               <Typography
//                                 sx={{
//                                   ...typography.smallText,
//                                   color: green[600],
//                                   bgcolor: `${green[500]}15`,
//                                   px: 0.5,
//                                   py: 0.125,
//                                   borderRadius: 0.5,
//                                   minWidth: 16,
//                                   textAlign: 'center',
//                                   fontSize: '0.6rem'
//                                 }}
//                               >
//                                 {subcategory.count}
//                               </Typography>
//                             </Stack>
//                           </Card>
//                         );
//                       })}
//                     </Stack>
//                   </Box>
//                 </Collapse>
//               </Box>
//             );
//           })}
//         </Stack>
//       </Box>
//     </Paper>
//   );

//   // Cleanup effect
//   useEffect(() => {
//     return () => {
//       if (templatePreviewUrl) {
//         URL.revokeObjectURL(templatePreviewUrl);
//       }
//       Object.values(cardPreviewUrls).forEach((url) => {
//         if (url) {
//           URL.revokeObjectURL(url);
//         }
//       });
//     };
//   }, []);

//   if (loading) {
//     return (
//       <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
//         <Stack
//           direction="row"
//           spacing={1.5}
//           justifyContent="center"
//           alignItems="center"
//           sx={{ minHeight: '30vh' }}
//         >
//           <CircularProgress size={24} />
//           <Typography sx={{ ...typography.bodyText }} color="text.secondary">
//             Loading templates...
//           </Typography>
//         </Stack>
//       </Container>
//     );
//   }

//   return (
//     <Box sx={{ position: 'relative' }}>
//       <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
//         {/* Page Header */}
//         <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
//           <Typography
//             sx={{
//               ...typography.mainTitle,
//               fontWeight: 'bold',
//               color: 'primary.main',
//               mb: 0.5
//             }}
//           >
//             View Templates
//           </Typography>
//           <Typography
//             sx={{
//               ...typography.smallText,
//               color: 'text.secondary'
//             }}
//           >
//             Browse and manage document templates • {filteredTemplates.length} template
//             {filteredTemplates.length !== 1 ? 's' : ''}
//             {selectedCategory && ` in "${selectedCategory}"`}
//             {selectedSubcategory && ` > "${selectedSubcategory}"`}
//           </Typography>
//         </Box>

//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: { xs: 1.5, md: 2 }, borderRadius: 1.5 }}
//             onClose={() => dispatch(clearTemplateError())}
//           >
//             <Typography sx={{ ...typography.smallText }}>Error: {error}</Typography>
//           </Alert>
//         )}

//         {/* Main Content Grid */}
//         <Grid container spacing={isMobile ? 1 : 1.5}>
//           {!isMobile && categoryData.length > 0 && (
//             <Grid item sm={3}>
//               {renderDesktopCategoryList()}
//             </Grid>
//           )}

//           <Grid item xs={12} sm={isMobile || categoryData.length === 0 ? 12 : 9}>
//             <Paper
//               elevation={0}
//               sx={{
//                 p: isMobile ? 1 : 1.5,
//                 bgcolor: 'white',
//                 border: `1px solid ${theme.palette.divider}`,
//                 borderRadius: 1.5,
//                 minHeight: isMobile ? 'auto' : 'calc(100vh - 160px)'
//               }}
//             >
//               {filteredTemplates.length > 0 ? (
//                 <Grid container spacing={isMobile ? 1 : 1.5}>
//                   {filteredTemplates.map((template) => {
//                     // Add null check for template
//                     if (!template || !template.documentId) return null;

//                     return (
//                       <Grid item xs={12} md={6} key={template.documentId}>
//                         <Card
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             p: 0,
//                             borderRadius: 1.5,
//                             boxShadow: 1,
//                             cursor: 'pointer',
//                             transition: 'all 0.2s ease',
//                             border: `1px solid ${theme.palette.divider}`,
//                             backgroundColor: 'background.paper',
//                             '&:hover': {
//                               boxShadow: 3,
//                               transform: 'translateY(-2px)',
//                               borderColor: theme.palette.primary.main
//                             },
//                             height: isMobile ? 200 : 220,
//                             position: 'relative',
//                             overflow: 'hidden'
//                           }}
//                         >
//                           {/* Action Buttons */}
//                           <Box
//                             sx={{
//                               position: 'absolute',
//                               top: 6,
//                               right: 6,
//                               zIndex: 3,
//                               bgcolor: 'rgba(255, 255, 255, 0.9)',
//                               borderRadius: 1,
//                               p: 0.25
//                             }}
//                           >
//                             <Stack direction="row" spacing={0.25}>
//                               <Tooltip title="Edit Template">
//                                 <IconButton
//                                   onClick={(e) => handleEdit(e, template)}
//                                   sx={{
//                                     ...iconButtonStyles.base,
//                                     ...iconButtonStyles.sizes.small,
//                                     '&:hover': {
//                                       bgcolor: blue[50],
//                                       color: blue[600]
//                                     }
//                                   }}
//                                 >
//                                   <EditIcon sx={{ fontSize: 12 }} />
//                                 </IconButton>
//                               </Tooltip>
//                               <Tooltip title="Delete Template">
//                                 <IconButton
//                                   onClick={(e) => handleDelete(e, template)}
//                                   sx={{
//                                     ...iconButtonStyles.base,
//                                     ...iconButtonStyles.sizes.small,
//                                     '&:hover': {
//                                       bgcolor: red[50],
//                                       color: red[600]
//                                     }
//                                   }}
//                                 >
//                                   <DeleteIcon sx={{ fontSize: 12 }} />
//                                 </IconButton>
//                               </Tooltip>
//                             </Stack>
//                           </Box>

//                           <Box
//                             sx={{
//                               width: isMobile ? '100%' : 140,
//                               height: isMobile ? 120 : '100%',
//                               flexShrink: 0,
//                               p: isMobile ? 1.5 : 2
//                             }}
//                           >
//                             {renderTemplatePreview(template)}
//                           </Box>

//                           <CardContent
//                             sx={{
//                               flex: 1,
//                               p: isMobile ? 1.5 : 2,
//                               display: 'flex',
//                               flexDirection: 'column',
//                               justifyContent: 'space-between'
//                             }}
//                           >
//                             <Box>
//                               <Typography
//                                 sx={{
//                                   ...typography.cardTitle,
//                                   fontWeight: 600,
//                                   mb: 1,
//                                   lineHeight: 1.3,
//                                   overflow: 'hidden',
//                                   display: '-webkit-box',
//                                   WebkitLineClamp: isMobile ? 3 : 2,
//                                   WebkitBoxOrient: 'vertical'
//                                 }}
//                               >
//                                 {template.documentName || 'Untitled Template'}
//                               </Typography>

//                               <Stack
//                                 direction="row"
//                                 alignItems="center"
//                                 spacing={0.5}
//                                 sx={{ mb: 0.75 }}
//                               >
//                                 <FolderIcon sx={{ fontSize: 10, color: grey[500] }} />
//                                 <Typography
//                                   sx={{ ...typography.smallText }}
//                                   color="text.secondary"
//                                   noWrap
//                                 >
//                                   {template.uploadedFile?.fileName || 'Unknown file'}
//                                 </Typography>
//                               </Stack>

//                               {/* Display subcategory */}
//                               {template.subcategory && (
//                                 <Stack
//                                   direction="row"
//                                   alignItems="center"
//                                   spacing={0.5}
//                                   sx={{ mb: 0.75 }}
//                                 >
//                                   <CategoryIcon sx={{ fontSize: 10, color: green[500] }} />
//                                   <Typography
//                                     sx={{ ...typography.smallText }}
//                                     color="text.secondary"
//                                     noWrap
//                                   >
//                                     {template.subcategory}
//                                   </Typography>
//                                 </Stack>
//                               )}

//                               <Typography sx={{ ...typography.smallText }} color="text.secondary">
//                                 {template.inputFields?.length || 0} field
//                                 {template.inputFields?.length !== 1 ? 's' : ''}
//                                 {template.inputFields?.some((f) => f.isRequired) &&
//                                   ' • Required fields'}
//                               </Typography>
//                             </Box>

//                             <Stack
//                               direction="row"
//                               justifyContent="space-between"
//                               alignItems="center"
//                               sx={{ mt: 'auto', pt: 1 }}
//                             >
//                               <Stack direction="row" alignItems="center" spacing={0.5}>
//                                 <TimeIcon sx={{ fontSize: 10, color: grey[500] }} />
//                                 <Typography sx={{ ...typography.smallText }} color="text.secondary">
//                                   {formatDate(template.createdDate)}
//                                 </Typography>
//                               </Stack>
//                               <Chip
//                                 label={`v${template.version}`}
//                                 size="small"
//                                 variant="outlined"
//                                 sx={{
//                                   fontSize: '0.5rem',
//                                   height: 16
//                                 }}
//                               />
//                             </Stack>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     );
//                   })}
//                 </Grid>
//               ) : (
//                 <Stack
//                   alignItems="center"
//                   justifyContent="center"
//                   spacing={1.5}
//                   sx={{ py: isMobile ? 3 : 6, textAlign: 'center' }}
//                 >
//                   <Box sx={{ opacity: 0.3 }}>
//                     <DocumentIcon sx={{ fontSize: isMobile ? 40 : 56, color: grey[400] }} />
//                   </Box>
//                   <Box>
//                     <Typography
//                       sx={{ ...typography.sectionTitle }}
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       No Templates Found
//                     </Typography>
//                     <Typography sx={{ ...typography.bodyText }} color="text.secondary">
//                       {selectedSubcategory
//                         ? `No templates available in "${selectedCategory} > ${selectedSubcategory}".`
//                         : selectedCategory
//                         ? `No templates available in the "${selectedCategory}" category.`
//                         : 'No templates available.'}
//                     </Typography>
//                   </Box>
//                 </Stack>
//               )}
//             </Paper>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Mobile Category Menu with nested structure */}
//       {isMobile && categoryData.length > 0 && (
//         <>
//           <Fab
//             onClick={(e) => setCategoryMenuAnchor(e.currentTarget)}
//             sx={{
//               position: 'fixed',
//               bottom: 16,
//               right: 16,
//               bgcolor: purple[500],
//               color: 'white',
//               width: 44,
//               height: 44,
//               '&:hover': {
//                 bgcolor: purple[600]
//               }
//             }}
//           >
//             <FilterIcon sx={{ fontSize: 18 }} />
//           </Fab>

//           <Menu
//             anchorEl={categoryMenuAnchor}
//             open={categoryMenuOpen}
//             onClose={() => setCategoryMenuAnchor(null)}
//             anchorOrigin={{
//               vertical: 'top',
//               horizontal: 'center'
//             }}
//             transformOrigin={{
//               vertical: 'bottom',
//               horizontal: 'center'
//             }}
//             PaperProps={{
//               sx: {
//                 maxHeight: '60vh',
//                 width: '280px',
//                 borderRadius: 1.5
//               }
//             }}
//           >
//             <Box sx={{ p: 1.5, pb: 0.75 }}>
//               <Typography sx={{ ...typography.bodyText, fontWeight: 600 }}>
//                 Select Category & Subcategory
//               </Typography>
//             </Box>
//             <Divider sx={{ opacity: 0.6 }} />

//             {categoryData.map((category) => {
//               if (!category || !category.category) return null;

//               const categoryColor = getCategoryColor(category.category);

//               return (
//                 <Box key={category.category}>
//                   {/* Category Header */}
//                   <MenuItem
//                     sx={{
//                       py: 1,
//                       bgcolor: `${categoryColor}08`,
//                       '&:hover': {
//                         bgcolor: `${categoryColor}15`
//                       }
//                     }}
//                   >
//                     <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%' }}>
//                       <Box
//                         sx={{
//                           width: 24,
//                           height: 24,
//                           borderRadius: 1,
//                           bgcolor: `${categoryColor}20`,
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           color: categoryColor
//                         }}
//                       >
//                         {React.cloneElement(getCategoryIcon(category.category), {
//                           style: { fontSize: 12 }
//                         })}
//                       </Box>
//                       <Typography
//                         sx={{
//                           ...typography.bodyText,
//                           fontWeight: 600,
//                           flex: 1
//                         }}
//                       >
//                         {category.category}
//                       </Typography>
//                       <Typography
//                         sx={{
//                           ...typography.smallText,
//                           color: categoryColor,
//                           bgcolor: `${categoryColor}15`,
//                           px: 0.5,
//                           py: 0.125,
//                           borderRadius: 0.5,
//                           minWidth: 16,
//                           textAlign: 'center'
//                         }}
//                       >
//                         {category.totalTemplates}
//                       </Typography>
//                     </Stack>
//                   </MenuItem>

//                   {/* Subcategories */}
//                   {category.subcategories?.map((subcategory) => {
//                     if (!subcategory || !subcategory.subcategory) return null;

//                     const isSelected =
//                       selectedCategory === category.category &&
//                       selectedSubcategory === subcategory.subcategory;

//                     return (
//                       <MenuItem
//                         key={subcategory.subcategoryId}
//                         onClick={() =>
//                           handleSubcategorySelect(
//                             category.category || '',
//                             subcategory.subcategory || ''
//                           )
//                         }
//                         sx={{
//                           py: 0.75,
//                           pl: 4,
//                           bgcolor: isSelected ? `${green[500]}08` : 'transparent',
//                           '&:hover': {
//                             bgcolor: `${green[500]}08`
//                           }
//                         }}
//                       >
//                         <Stack
//                           direction="row"
//                           alignItems="center"
//                           spacing={1}
//                           sx={{ width: '100%' }}
//                         >
//                           <Box
//                             sx={{
//                               width: 4,
//                               height: 16,
//                               borderRadius: 2,
//                               bgcolor: isSelected ? green[500] : grey[300]
//                             }}
//                           />
//                           <Typography
//                             sx={{
//                               ...typography.smallText,
//                               fontWeight: isSelected ? 600 : 400,
//                               flex: 1
//                             }}
//                           >
//                             {subcategory.subcategory}
//                           </Typography>
//                           <Typography
//                             sx={{
//                               ...typography.smallText,
//                               color: green[600],
//                               bgcolor: `${green[500]}15`,
//                               px: 0.5,
//                               py: 0.125,
//                               borderRadius: 0.5,
//                               minWidth: 16,
//                               textAlign: 'center',
//                               fontSize: '0.6rem'
//                             }}
//                           >
//                             {subcategory.count}
//                           </Typography>
//                         </Stack>
//                       </MenuItem>
//                     );
//                   })}

//                   {category !== categoryData[categoryData.length - 1] && (
//                     <Divider sx={{ opacity: 0.3 }} />
//                   )}
//                 </Box>
//               );
//             })}
//           </Menu>
//         </>
//       )}

//       {/* Confirmation Dialog */}
//       <ConfirmationDialog
//         open={confirmDialogOpen}
//         title={getDialogTitle()}
//         message={getDialogMessage()}
//         confirmButtonText={getDialogButtonText()}
//         confirmButtonColor={getDialogButtonColor()}
//         onConfirm={handleConfirmDelete}
//         onCancel={handleCloseDeleteConfirmation}
//         loading={deleteLoading}
//       />

//       {/* Preview Modal */}
//       <Dialog
//         open={previewModalOpen}
//         onClose={handleClosePreview}
//         maxWidth="xl"
//         fullWidth
//         fullScreen={isMobile}
//         PaperProps={{
//           sx: {
//             borderRadius: isMobile ? 0 : 1.5,
//             maxHeight: '95vh',
//             height: isMobile ? '100vh' : '90vh',
//             display: 'flex',
//             flexDirection: 'column'
//           }
//         }}
//       >
//         <DialogTitle
//           sx={{
//             p: isMobile ? 1.5 : 2,
//             pb: isMobile ? 1 : 1.5,
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'flex-start',
//             flexShrink: 0
//           }}
//         >
//           <Box>
//             <Typography
//               sx={{
//                 ...typography.mainTitle,
//                 fontWeight: 600,
//                 mb: 0.25
//               }}
//             >
//               {selectedTemplate?.documentName}
//             </Typography>
//             <Typography sx={{ ...typography.smallText }} color="text.secondary">
//               {selectedTemplate?.category}
//               {selectedTemplate?.subcategory && ` > ${selectedTemplate.subcategory}`} • Created{' '}
//               {selectedTemplate && formatDate(selectedTemplate.createdDate)}
//             </Typography>
//           </Box>
//           <IconButton
//             onClick={handleClosePreview}
//             sx={{
//               ...iconButtonStyles.base,
//               ...iconButtonStyles.sizes.medium,
//               bgcolor: grey[100],
//               '&:hover': { bgcolor: grey[200] }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <Divider sx={{ opacity: 0.6, flexShrink: 0 }} />

//         <DialogContent
//           sx={{
//             p: isMobile ? 1 : 2,
//             overflow: 'auto',
//             flex: 1,
//             display: 'flex',
//             flexDirection: 'column'
//           }}
//         >
//           {selectedTemplate && (
//             <Stack spacing={isMobile ? 1.5 : 2} sx={{ height: '100%' }}>
//               {previewLoading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//                   <CircularProgress size={24} />
//                   <Typography sx={{ ml: 2 }}>Loading document...</Typography>
//                 </Box>
//               ) : templatePreviewUrl ? (
//                 <Box sx={{ flex: 1, minHeight: 0 }}>
//                   {selectedTemplate.uploadedFile?.fileType === 'pdf' ? (
//                     renderPdfPreviewWithThumbnails()
//                   ) : (
//                     <Box
//                       sx={{
//                         position: 'relative',
//                         display: 'flex',
//                         justifyContent: 'center',
//                         border: `1px solid ${theme.palette.divider}`,
//                         borderRadius: 1.5,
//                         overflow: 'auto',
//                         bgcolor: grey[50],
//                         height: '50vh'
//                       }}
//                     >
//                       <Box
//                         ref={pdfContainerRef}
//                         sx={{
//                           position: 'relative',
//                           display: 'inline-block',
//                           isolation: 'isolate'
//                         }}
//                       >
//                         <img
//                           src={templatePreviewUrl}
//                           alt={selectedTemplate.documentName}
//                           style={{
//                             maxWidth: '100%',
//                             maxHeight: '100%',
//                             objectFit: 'contain'
//                           }}
//                           onLoad={() => setOverlayRenderTrigger((prev) => prev + 1)}
//                         />

//                         {/* Render overlays for image (single-page, so pageNumber === 1) */}
//                         {selectedTemplate?.inputFields
//                           ?.filter((field: any) => field.pageNumber === 1)
//                           .map((field: any) => (
//                             <ViewInputFieldOverlay
//                               key={field.id}
//                               field={field}
//                               pdfContainerRef={pdfContainerRef}
//                               handleFieldClick={handleFieldClick}
//                               isMobile={isMobile}
//                               isTemplateView={true}
//                             />
//                           ))}
//                       </Box>
//                     </Box>
//                   )}
//                 </Box>
//               ) : (
//                 <Stack
//                   alignItems="center"
//                   spacing={1}
//                   sx={{ py: isMobile ? 2 : 3, textAlign: 'center' }}
//                 >
//                   {getFileTypeIcon(selectedTemplate.uploadedFile?.fileName || 'document')}
//                   <Typography sx={{ ...typography.bodyText }} color="text.secondary">
//                     Preview not available
//                   </Typography>
//                 </Stack>
//               )}

//               {/* Template Details */}
//               <Paper
//                 sx={{
//                   p: isMobile ? 1.5 : 2,
//                   bgcolor: grey[50],
//                   borderRadius: 1.5,
//                   maxHeight: '30vh',
//                   overflowY: 'auto',
//                   flexShrink: 0
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     ...typography.sectionTitle,
//                     fontWeight: 600,
//                     mb: 1
//                   }}
//                 >
//                   Template Details
//                 </Typography>
//                 <Grid container spacing={isMobile ? 1 : 1.5}>
//                   <Grid item xs={6} sm={3}>
//                     <Typography
//                       sx={{ ...typography.smallText }}
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       File Size
//                     </Typography>
//                     <Typography sx={{ ...typography.bodyText }}>
//                       {selectedTemplate.uploadedFile?.fileSize
//                         ? `${(selectedTemplate.uploadedFile.fileSize / 1024 / 1024).toFixed(1)}MB`
//                         : 'Unknown'}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={6} sm={3}>
//                     <Typography
//                       sx={{ ...typography.smallText }}
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       Form Fields
//                     </Typography>
//                     <Typography sx={{ ...typography.bodyText }}>
//                       {selectedTemplate.inputFields?.length || 0}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={6} sm={3}>
//                     <Typography
//                       sx={{ ...typography.smallText }}
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       Last Modified
//                     </Typography>
//                     <Typography sx={{ ...typography.bodyText }}>
//                       {formatDate(selectedTemplate.lastModified)}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={6} sm={3}>
//                     <Typography
//                       sx={{ ...typography.smallText }}
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       Version
//                     </Typography>
//                     <Typography sx={{ ...typography.bodyText }}>
//                       {selectedTemplate.version}
//                     </Typography>
//                   </Grid>
//                 </Grid>

//                 {/* Show subcategory in details */}
//                 {selectedTemplate.subcategory && (
//                   <Box sx={{ mt: 1.5 }}>
//                     <Grid container spacing={isMobile ? 1 : 1.5}>
//                       <Grid item xs={6} sm={3}>
//                         <Typography
//                           sx={{ ...typography.smallText }}
//                           color="text.secondary"
//                           gutterBottom
//                         >
//                           Category
//                         </Typography>
//                         <Typography sx={{ ...typography.bodyText }}>
//                           {selectedTemplate.category}
//                         </Typography>
//                       </Grid>
//                       <Grid item xs={6} sm={3}>
//                         <Typography
//                           sx={{ ...typography.smallText }}
//                           color="text.secondary"
//                           gutterBottom
//                         >
//                           Subcategory
//                         </Typography>
//                         <Typography sx={{ ...typography.bodyText }}>
//                           {selectedTemplate.subcategory}
//                         </Typography>
//                       </Grid>
//                     </Grid>
//                   </Box>
//                 )}

//                 {selectedTemplate.inputFields && selectedTemplate.inputFields.length > 0 && (
//                   <Box sx={{ mt: 2 }}>
//                     <Typography
//                       sx={{
//                         ...typography.sectionTitle,
//                         fontWeight: 600,
//                         mb: 1
//                       }}
//                     >
//                       Form Fields ({selectedTemplate.inputFields.length})
//                     </Typography>
//                     <Grid container spacing={1}>
//                       {selectedTemplate.inputFields.map((field, index) => (
//                         <Grid item xs={12} sm={6} key={field.id}>
//                           <Box
//                             sx={{
//                               p: 1,
//                               border: `1px solid ${theme.palette.divider}`,
//                               borderRadius: 1,
//                               bgcolor: 'white'
//                             }}
//                           >
//                             <Stack direction="row" alignItems="center" spacing={1}>
//                               <Chip
//                                 label={field.type}
//                                 size="small"
//                                 sx={{
//                                   fontSize: '0.6rem',
//                                   height: 18,
//                                   textTransform: 'capitalize'
//                                 }}
//                               />
//                               <Typography sx={{ ...typography.smallText, flex: 1 }}>
//                                 {field.fieldLabel}
//                               </Typography>
//                               {field.isRequired && (
//                                 <Typography sx={{ ...typography.smallText, color: red[500] }}>
//                                   Required
//                                 </Typography>
//                               )}
//                             </Stack>
//                             <Typography
//                               sx={{ ...typography.smallText, color: 'text.secondary', mt: 0.5 }}
//                             >
//                               Page {field.pageNumber} • Position ({field.x}, {field.y})
//                               {field.xPercent && field.yPercent && (
//                                 <>
//                                   {' '}
//                                   • ({field.xPercent.toFixed(1)}%, {field.yPercent.toFixed(1)}%)
//                                 </>
//                               )}
//                             </Typography>
//                           </Box>
//                         </Grid>
//                       ))}
//                     </Grid>
//                   </Box>
//                 )}
//               </Paper>
//             </Stack>
//           )}
//         </DialogContent>

//         <Divider sx={{ opacity: 0.6, flexShrink: 0 }} />

//         <DialogActions sx={{ p: isMobile ? 1.5 : 2, gap: 0.75, flexShrink: 0 }}>
//           <Button
//             onClick={handleClosePreview}
//             sx={{
//               ...buttonStyles.base,
//               ...buttonStyles.sizes.small,
//               ...buttonStyles.variants.outlined
//             }}
//           >
//             Close
//           </Button>
//           <Button
//             onClick={() =>
//               selectedTemplate && handleEdit({ stopPropagation: () => {} } as any, selectedTemplate)
//             }
//             startIcon={<EditIcon />}
//             sx={{
//               ...buttonStyles.base,
//               ...buttonStyles.sizes.small,
//               ...buttonStyles.variants.contained
//             }}
//           >
//             Edit Template
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ViewTemplatesListComponent;







import {
  Category as CategoryIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Description as DocumentIcon,
  Edit as EditIcon,
  ExpandLess,
  ExpandMore,
  FilterList as FilterIcon,
  Folder as FolderIcon,
  VisibilityOff as HideThumbnailsIcon,
  Image as ImageIcon,
  PictureAsPdf as PdfIcon,
  Visibility as PreviewIcon,
  ViewSidebar as ThumbnailsIcon,
  AccessTime as TimeIcon
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { blue, grey, purple, red, green } from '@mui/material/colors';
import { useAppSelector } from 'app/hooks';
import { AppDispatch, RootState } from 'app/store';
import ConfirmationDialog from 'commonComponents/ConfirmationDialog';
import { useWindowSize } from 'hooks/useWindowSize';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useDispatch, useSelector } from 'react-redux';
import axiosInstance from 'Services/APIService';
import {
  clearTemplateError,
  deleteTemplateById,
  getTemplateById,
  listTemplates
} from 'slices/payrolslices/documentTemplateSlice';
import {
  buttonStyles,
  getCategoryColor,
  getCategoryIcon,
  typography
} from './documentHelper/DocumentHelperFunctions';
import { useDocumentManagement } from './DocumentManagementContext';
import { CategoryData, Template } from './types';
import ViewInputFieldOverlay from './viewTempletsList/ViewInputFieldOverlay';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const iconButtonStyles = {
  base: {
    borderRadius: 1.5,
    transition: 'all 0.2s ease'
  },
  sizes: {
    small: {
      width: 24,
      height: 24
    },
    medium: {
      width: 28,
      height: 28
    }
  }
};

const ViewTemplatesListComponent: React.FC = () => {
  const { openCreatePage } = useDocumentManagement();
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const windowSize = useWindowSize();

  // Redux state
  const { loading, error, templates, categories, totalTemplates } = useSelector(
    (state: RootState) => state.documentTemplate
  );

  console.log('Templates from Redux:', templates);

  // Local state
  const [displayTemplates, setDisplayTemplates] = useState<Template[]>([]);
  const [filteredTemplates, setFilteredTemplates] = useState<Template[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [pdfNumPages, setPdfNumPages] = useState<number>(0);
  const [currentPdfPage, setCurrentPdfPage] = useState<number>(1);
  const [templatePreviewUrl, setTemplatePreviewUrl] = useState<string | null>(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [cardPreviewUrls, setCardPreviewUrls] = useState<{ [key: string]: string }>({});

  // Confirmation dialog state
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState<Template | null>(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Thumbnail sidebar state
  const [showThumbnails, setShowThumbnails] = useState(true);
  const [thumbnailsLoaded, setThumbnailsLoaded] = useState<Set<number>>(new Set());

  // Category and subcategory state for nested structure
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());
  const [categoryData, setCategoryData] = useState<CategoryData[]>([]);

  // Mobile category menu
  const [categoryMenuAnchor, setCategoryMenuAnchor] = useState<null | HTMLElement>(null);
  const categoryMenuOpen = Boolean(categoryMenuAnchor);

  // PDF container ref for coordinate calculations
  const pdfContainerRef = useRef<HTMLDivElement>(null);
  const [overlayRenderTrigger, setOverlayRenderTrigger] = useState(0);

  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
  const selectedServiceTitle = useAppSelector(
    (state) => state.serviceSelected.selectedServiceTitle
  );

  // Calculate PDF width dynamically
  const calculatePdfWidth = () => {
    const sidebarWidth = showThumbnails && pdfNumPages > 1 ? 120 : 0;
    const padding = isMobile ? 32 : 48;
    const toolbarWidth = 100;
    const availableWidth = windowSize.width - sidebarWidth - padding - toolbarWidth;

    return Math.max(Math.min(availableWidth, isMobile ? 350 : 700), 280);
  };

  // Field click handler for template view
  const handleFieldClick = useCallback((field: any) => {
    console.log('Template field clicked:', field);
  }, []);

  // Confirmation dialog helper functions
  const getDialogTitle = () => 'Confirm Delete Template';
  const getDialogMessage = () =>
    templateToDelete
      ? `Are you sure you want to <strong>delete</strong> the template "<strong>${templateToDelete.documentName}</strong>"? This action cannot be undone.`
      : '';
  const getDialogButtonText = () => 'Delete Template';
  const getDialogButtonColor = (): 'primary' | 'error' | 'success' => 'error';

  // Delete handlers
  const handleOpenDeleteConfirmation = (template: Template) => {
    setTemplateToDelete(template);
    setConfirmDialogOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    setConfirmDialogOpen(false);
    setTemplateToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (!templateToDelete || !selectedProjectId || !selectedServiceTitle) return;

    setDeleteLoading(true);
    try {
      await dispatch(
        deleteTemplateById({
          group_id: selectedProjectId,
          service_id: selectedServiceTitle,
          category: templateToDelete.category || "",
          category_id: templateToDelete.categoryId || "",
          document_id: templateToDelete.documentId || ""
        })
      ).unwrap();

      await dispatch(
        listTemplates({
          group_id: selectedProjectId,
          service_id: selectedServiceTitle,
          category_id: null
        })
      ).unwrap();

      handleCloseDeleteConfirmation();
    } catch (error) {
      console.error('Error deleting template:', error);
    } finally {
      setDeleteLoading(false);
    }
  };

  // Trigger overlay re-render when PDF loads/scales
  useEffect(() => {
    if (templatePreviewUrl && pdfNumPages > 0) {
      const timer = setTimeout(() => {
        setOverlayRenderTrigger((prev) => prev + 1);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [templatePreviewUrl, pdfNumPages, currentPdfPage]);

  // Load templates on component mount
  useEffect(() => {
    const loadTemplates = async () => {
      if (selectedProjectId && selectedServiceTitle) {
        try {
          await dispatch(
            listTemplates({
              group_id: selectedProjectId,
              service_id: selectedServiceTitle,
              category_id: null
            })
          ).unwrap();
        } catch (error) {
          console.error('Failed to load templates:', error);
        }
      }
    };

    loadTemplates();
  }, [dispatch, selectedProjectId, selectedServiceTitle]);

  // Process nested category-subcategory structure with proper initialization
  useEffect(() => {
    let templatesData: Template[] = [];
    let processedCategoryData: CategoryData[] = [];

    console.log('Redux templates:', templates);
    console.log('Redux categories:', categories);

    if (templates && templates.length > 0) {
      templatesData = templates.filter((template) => template && template.documentId);
    }

    if (categories && categories.length > 0) {
      // Categories are now properly formatted as CategoryData[]
      // Extract nested structure from templates for UI display
      processedCategoryData = categories.map((category) => {
        const categoryTemplates = templatesData.filter((t) => t.category === category.category);

        // Group templates by subcategory
        const subcategoriesMap = new Map();
        categoryTemplates.forEach((template) => {
          const subcategory = template.subcategory || 'General';
          if (!subcategoriesMap.has(subcategory)) {
            subcategoriesMap.set(subcategory, {
              subcategoryId: `${category.category}-${subcategory}`
                .toLowerCase()
                .replace(/\s+/g, '-'),
              subcategory: subcategory,
              templates: [],
              count: 0
            });
          }
          subcategoriesMap.get(subcategory).templates.push(template);
          subcategoriesMap.get(subcategory).count++;
        });

        return {
          categoryId: `cat-${category.category}`.toLowerCase().replace(/\s+/g, '-'),
          category: category.category,
          subcategories: Array.from(subcategoriesMap.values()),
          totalTemplates: categoryTemplates.length
        };
      });
    }

    console.log('Processed templates data:', templatesData);
    console.log('Processed category data:', processedCategoryData);

    setDisplayTemplates(templatesData);
    setCategoryData(processedCategoryData);

    // Auto-expand first category and select first subcategory
    if (processedCategoryData.length > 0 && !selectedCategory) {
      const firstCategory = processedCategoryData[0];
      if (firstCategory && firstCategory.category) {
        setSelectedCategory(firstCategory.category);
        setExpandedCategories(new Set([firstCategory.category]));

        if (
          firstCategory.subcategories &&
          firstCategory.subcategories.length > 0 &&
          !selectedSubcategory
        ) {
          const firstSubcategory = firstCategory.subcategories[0];
          if (firstSubcategory && firstSubcategory.subcategory) {
            setSelectedSubcategory(firstSubcategory.subcategory);
          }
        }
      }
    }
  }, [templates, categories, loading]);

  // Load card previews with null checks
  useEffect(() => {
    const fetchCardPreviews = async () => {
      const newPreviewUrls: { [key: string]: string } = {};

      if (!displayTemplates || displayTemplates.length === 0) return;

      for (const template of displayTemplates) {
        if (!template || !template.documentId || !template.uploadedFile?.storedFilePath) {
          continue;
        }

        try {
          const encodedPath = encodeURIComponent(template.uploadedFile.storedFilePath);
          const response = await axiosInstance.get(`/avatar/get-avatar?path=${encodedPath}`, {
            responseType: 'blob'
          });

          if (template.uploadedFile.fileType === 'pdf') {
            const pdfBlobUrl = URL.createObjectURL(response.data);
            newPreviewUrls[template.documentId] = pdfBlobUrl;
          } else {
            const imageUrl = URL.createObjectURL(response.data);
            newPreviewUrls[template.documentId] = imageUrl;
          }
        } catch (error) {
          console.error(`Error fetching card preview for ${template.documentName}:`, error);
        }
      }

      setCardPreviewUrls(newPreviewUrls);
    };

    if (displayTemplates && displayTemplates.length > 0) {
      fetchCardPreviews();
    }

    return () => {
      Object.values(cardPreviewUrls).forEach((url) => {
        if (url) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [displayTemplates]);

  // Filter templates by selected category and subcategory
  useEffect(() => {
    if (!displayTemplates) {
      setFilteredTemplates([]);
      return;
    }

    console.log('Filtering templates with:', displayTemplates);

    let filtered = displayTemplates.filter((template) => template && template.documentId);

    if (selectedCategory) {
      filtered = filtered.filter((template) => template.category === selectedCategory);
    }

    if (selectedSubcategory) {
      filtered = filtered.filter((template) => template.subcategory === selectedSubcategory);
    }

    setFilteredTemplates(filtered);
  }, [selectedCategory, selectedSubcategory, displayTemplates]);

  // Fetch template preview for modal
  const fetchTemplatePreview = async (template: Template) => {
    if (!template?.uploadedFile?.storedFilePath) {
      return null;
    }

    try {
      setPreviewLoading(true);
      const encodedPath = encodeURIComponent(template.uploadedFile.storedFilePath);
      const response = await axiosInstance.get(`/avatar/get-avatar?path=${encodedPath}`, {
        responseType: 'blob'
      });

      const blobUrl = URL.createObjectURL(response.data);
      setTemplatePreviewUrl(blobUrl);
      return blobUrl;
    } catch (error) {
      console.error('Error fetching template preview:', error);
      return null;
    } finally {
      setPreviewLoading(false);
    }
  };

  const getFileTypeIcon = (fileName: string) => {
    const extension = fileName?.split('.').pop()?.toLowerCase();
    const iconSize = isMobile ? 32 : 48;

    switch (extension) {
      case 'pdf':
        return <PdfIcon sx={{ fontSize: iconSize, color: red[500] }} />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <ImageIcon sx={{ fontSize: iconSize, color: blue[500] }} />;
      default:
        return <DocumentIcon sx={{ fontSize: iconSize, color: grey[500] }} />;
    }
  };

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  // Handle category expansion/collapse
  const handleCategoryToggle = (categoryName: string) => {
    const newExpanded = new Set(expandedCategories);
    if (newExpanded.has(categoryName)) {
      newExpanded.delete(categoryName);
    } else {
      newExpanded.add(categoryName);
    }
    setExpandedCategories(newExpanded);
  };

  // Handle subcategory selection
  const handleSubcategorySelect = (categoryName: string, subcategoryName: string) => {
    setSelectedCategory(categoryName);
    setSelectedSubcategory(subcategoryName);
    setCategoryMenuAnchor(null);
  };

  const handleTemplateClick = async (template: Template) => {
    if (!template || !template.documentId) return;

    setSelectedTemplate(template);
    setPreviewModalOpen(true);
    setCurrentPdfPage(1);
    setThumbnailsLoaded(new Set());
    setOverlayRenderTrigger(0);

    if (selectedProjectId && selectedServiceTitle) {
      try {
        const response = await dispatch(
          getTemplateById({
            group_id: selectedProjectId,
            service_id: selectedServiceTitle,
            category: template.category,
            document_id: template.documentId,
            category_id: template.categoryId
          })
        ).unwrap();

        let fullTemplate: Template;
        if ('template' in response && response.template) {
          fullTemplate = response.template as Template;
        } else {
          fullTemplate = response as Template;
        }

        setSelectedTemplate(fullTemplate);
        await fetchTemplatePreview(fullTemplate);
      } catch (error) {
        console.error('Error fetching template details:', error);
        await fetchTemplatePreview(template);
      }
    }
  };

  const handleClosePreview = () => {
    setPreviewModalOpen(false);
    setSelectedTemplate(null);
    setThumbnailsLoaded(new Set());
    setOverlayRenderTrigger(0);
    if (templatePreviewUrl) {
      URL.revokeObjectURL(templatePreviewUrl);
      setTemplatePreviewUrl(null);
    }
    setPdfNumPages(0);
  };

  const handleEdit = (e: React.MouseEvent, template: Template) => {
    e.stopPropagation();
    if (template && template.documentId) {
      openCreatePage(template.documentId, template.documentName, template.categoryId, template);
    }
  };

  const handleDelete = async (e: React.MouseEvent, template: Template) => {
    e.stopPropagation();
    if (template && template.documentId) {
      handleOpenDeleteConfirmation(template);
    }
  };

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setPdfNumPages(numPages);
    setTimeout(() => {
      setOverlayRenderTrigger((prev) => prev + 1);
    }, 100);
  };

  const onDocumentLoadError = (error: Error) => {
    console.error('PDF load error:', error);
  };

  // Enhanced thumbnail rendering
  const renderThumbnail = (pageNumber: number) => {
    const isSelected = currentPdfPage === pageNumber;
    const fieldsOnPage =
      selectedTemplate?.inputFields?.filter((field) => field.pageNumber === pageNumber) ?? [];

    return (
      <Box
        key={`thumbnail-${pageNumber}`}
        onClick={() => setCurrentPdfPage(pageNumber)}
        sx={{
          position: 'relative',
          cursor: 'pointer',
          border: isSelected ? '2px solid #1976d2' : '1px solid #ddd',
          borderRadius: 1,
          bgcolor: isSelected ? '#e3f2fd' : 'white',
          overflow: 'hidden',
          transition: 'all 0.2s ease',
          '&:hover': {
            borderColor: '#1976d2',
            transform: 'scale(1.02)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          },
          width: isMobile ? 60 : 80,
          height: isMobile ? 84 : 112,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 1,
          flexShrink: 0
        }}
      >
        <Document file={templatePreviewUrl} loading={null} error={null}>
          <Page
            pageNumber={pageNumber}
            width={isMobile ? 50 : 70}
            height={isMobile ? 70 : 98}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            loading={
              <Box
                sx={{
                  width: isMobile ? 50 : 70,
                  height: isMobile ? 70 : 98,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: grey[50]
                }}
              >
                <CircularProgress size={16} />
              </Box>
            }
            onRenderSuccess={() => {
              setThumbnailsLoaded((prev) => new Set([...Array.from(prev), pageNumber]));
            }}
          />
        </Document>

        <Box
          sx={{
            position: 'absolute',
            bottom: 2,
            left: 2,
            bgcolor: isSelected ? '#1976d2' : 'rgba(0,0,0,0.7)',
            color: 'white',
            px: 0.5,
            py: 0.25,
            borderRadius: 0.5,
            fontSize: isMobile ? '8px' : '10px',
            fontWeight: 600,
            lineHeight: 1,
            minWidth: 16,
            textAlign: 'center'
          }}
        >
          {pageNumber}
        </Box>

        {fieldsOnPage.length > 0 && (
          <Box
            sx={{
              position: 'absolute',
              top: 2,
              right: 2,
              bgcolor: '#ff9800',
              color: 'white',
              minWidth: 16,
              height: 16,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: isMobile ? '8px' : '9px',
              fontWeight: 600,
              lineHeight: 1
            }}
          >
            {fieldsOnPage.length}
          </Box>
        )}
      </Box>
    );
  };

  // Add this function to render empty template canvas with field overlays
  const renderEmptyTemplateCanvas = () => {
    return (
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1.5,
          overflow: 'auto',
          bgcolor: '#fafafa',
          height: '50vh',
          backgroundImage: `
          linear-gradient(rgba(156, 163, 175, 0.1) 1px, transparent 1px),
          linear-gradient(90deg, rgba(156, 163, 175, 0.1) 1px, transparent 1px)
        `,
          backgroundSize: '20px 20px'
        }}
      >
        <Box
          ref={pdfContainerRef}
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            minWidth: isMobile ? 350 : 800,
            minHeight: isMobile ? 400 : 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {/* Empty state message */}
          {(!selectedTemplate?.inputFields || selectedTemplate.inputFields.length === 0) && (
            <Box sx={{ textAlign: 'center', opacity: 0.5 }}>
              <DocumentIcon sx={{ fontSize: 48, color: grey[400], mb: 1 }} />
              <Typography variant="body2" color="text.secondary">
                Empty Template Canvas
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Field overlays will appear here
              </Typography>
            </Box>
          )}

          {/* Render field overlays for empty template */}
          {selectedTemplate?.inputFields
            ?.filter((field: any) => field.pageNumber === 1)
            .map((field: any) => (
              <ViewInputFieldOverlay
                key={field.id}
                field={field}
                pdfContainerRef={pdfContainerRef as React.RefObject<HTMLDivElement>}
                handleFieldClick={handleFieldClick}
                isMobile={isMobile}
                isTemplateView={true}
              />
            ))}
        </Box>
      </Box>
    );
  };

  // PDF preview with thumbnails
  const renderPdfPreviewWithThumbnails = () => (
    <Box
      sx={{
        display: 'flex',
        height: '65vh',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1.5,
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      {/* Thumbnails Sidebar */}
      {showThumbnails && pdfNumPages > 1 && (
        <Box
          sx={{
            width: isMobile ? 100 : 120,
            minWidth: isMobile ? 100 : 120,
            borderRight: '1px solid #e0e0e0',
            bgcolor: '#fafafa',
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            p: 1,
            position: 'relative',
            zIndex: theme.zIndex.drawer,
            '::-webkit-scrollbar': { width: '6px' },
            '::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '3px' },
            '::-webkit-scrollbar-thumb': {
              background: '#c1c1c1',
              borderRadius: '3px',
              '&:hover': { background: '#a8a8a8' }
            },
            scrollbarWidth: 'thin',
            scrollbarColor: '#c1c1c1 #f1f1f1'
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontSize: isMobile ? '8px' : '10px',
              fontWeight: 600,
              textAlign: 'center',
              color: '#666',
              mb: 0.5
            }}
          >
            Pages ({pdfNumPages})
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              width: '100%',
              alignItems: 'center'
            }}
          >
            {Array.from(new Array(pdfNumPages), (_, index) => renderThumbnail(index + 1))}
          </Box>
        </Box>
      )}

      {/* Main PDF Viewer */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          position: 'relative',
          zIndex: 1
        }}
      >
        {/* PDF Toolbar */}
        <Box
          sx={{
            borderBottom: `1px solid ${theme.palette.divider}`,
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: grey[50],
            flexShrink: 0,
            zIndex: 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {pdfNumPages > 1 && (
              <Tooltip title={showThumbnails ? 'Hide Thumbnails' : 'Show Thumbnails'}>
                <IconButton
                  onClick={() => setShowThumbnails(!showThumbnails)}
                  size="small"
                  sx={{
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    '&:hover': { bgcolor: grey[100] }
                  }}
                >
                  {showThumbnails ? <HideThumbnailsIcon /> : <ThumbnailsIcon />}
                </IconButton>
              </Tooltip>
            )}

            <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
              Page {currentPdfPage} of {pdfNumPages}
            </Typography>
          </Box>

          {pdfNumPages > 1 && (
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Button
                onClick={() => setCurrentPdfPage(Math.max(1, currentPdfPage - 1))}
                disabled={currentPdfPage <= 1}
                size="small"
                sx={{
                  ...buttonStyles.base,
                  ...buttonStyles.sizes.small,
                  ...buttonStyles.variants.outlined,
                  minWidth: 40
                }}
              >
                ←
              </Button>
              <Button
                onClick={() => setCurrentPdfPage(Math.min(pdfNumPages, currentPdfPage + 1))}
                disabled={currentPdfPage >= pdfNumPages}
                size="small"
                sx={{
                  ...buttonStyles.base,
                  ...buttonStyles.sizes.small,
                  ...buttonStyles.variants.outlined,
                  minWidth: 40
                }}
              >
                →
              </Button>
            </Box>
          )}
        </Box>

        {/* Main PDF Display Area */}
        <Box
          ref={pdfContainerRef}
          sx={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'auto',
            p: 2,
            bgcolor: grey[50],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            minHeight: 0,
            position: 'relative',
            zIndex: 1
          }}
        >
          <Box
            sx={{
              position: 'relative',
              maxWidth: '100%',
              maxHeight: '100%',
              isolation: 'isolate'
            }}
          >
            <Document
              file={templatePreviewUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
              loading={
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <CircularProgress size={24} />
                  <Typography sx={{ mt: 1 }}>Loading PDF...</Typography>
                </Box>
              }
              error={
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="error">Failed to load PDF. Please try again.</Typography>
                </Box>
              }
            >
              <Page
                pageNumber={currentPdfPage}
                width={calculatePdfWidth()}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                loading={<CircularProgress size={20} />}
                onRenderSuccess={() => {
                  setTimeout(() => {
                    setOverlayRenderTrigger((prev) => prev + 1);
                  }, 100);
                }}
              />
            </Document>

            {/* Field overlays */}
            {selectedTemplate?.inputFields
              ?.filter((field: any) => field.pageNumber === currentPdfPage)
              .map((field: any) => (
                <ViewInputFieldOverlay
                  key={field.id}
                  field={field}
                  pdfContainerRef={pdfContainerRef as React.RefObject<HTMLDivElement>}
                  handleFieldClick={handleFieldClick}
                  isMobile={isMobile}
                  isTemplateView={true}
                />
              ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );

  // Template preview render function with null checks and empty template support
  const renderTemplatePreview = (template: Template) => {
    if (!template || !template.documentId) return null;

    const previewUrl = cardPreviewUrls[template.documentId];
    const isEmptyTemplate = !template.uploadedFile?.storedFilePath;

    return (
      <Box
        sx={{
          height: '100%',
          width: '100%',
          bgcolor: isEmptyTemplate ? '#f0f9ff' : '#f8f9fa',
          borderRadius: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          cursor: 'pointer',
          overflow: 'hidden',
          border: `2px solid ${isEmptyTemplate ? blue[200] : grey[200]}`,
          '&:hover': {
            bgcolor: isEmptyTemplate ? '#e0f2fe' : '#e9ecef',
            borderColor: theme.palette.primary.main,
            '& .preview-overlay': {
              opacity: 1
            }
          }
        }}
        onClick={() => handleTemplateClick(template)}
      >
        {isEmptyTemplate ? (
          // Show empty template indicator
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
              p: 2
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1,
                bgcolor: blue[100],
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 1
              }}
            >
              <DocumentIcon sx={{ fontSize: 24, color: blue[600] }} />
            </Box>
            <Typography
              sx={{
                ...typography.smallText,
                color: blue[700],
                textAlign: 'center',
                fontWeight: 600
              }}
            >
              Empty Template
            </Typography>
            <Typography
              sx={{
                ...typography.smallText,
                color: blue[600],
                textAlign: 'center',
                fontSize: '10px'
              }}
            >
              {template.inputFields?.length || 0} fields
            </Typography>
          </Box>
        ) : previewUrl ? (
          template.uploadedFile?.fileType === 'pdf' ? (
            <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
              <Document
                file={previewUrl}
                loading={
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%'
                    }}
                  >
                    <CircularProgress size={16} />
                  </Box>
                }
                error={
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%'
                    }}
                  >
                    <PdfIcon sx={{ fontSize: 32, color: red[500], opacity: 0.6 }} />
                    <Typography sx={{ ...typography.smallText, color: grey[600] }}>PDF</Typography>
                  </Box>
                }
                noData={
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%'
                    }}
                  >
                    <PdfIcon sx={{ fontSize: 32, color: red[500], opacity: 0.6 }} />
                    <Typography sx={{ ...typography.smallText, color: grey[600] }}>PDF</Typography>
                  </Box>
                }
              >
                <Page
                  pageNumber={1}
                  width={120}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  loading={<CircularProgress size={12} />}
                />
              </Document>
            </Box>
          ) : (
            <img
              src={previewUrl}
              alt={template.documentName || 'Template'}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
          )
        ) : (
          <Box
            sx={{
              opacity: 0.6,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.5
            }}
          >
            {getFileTypeIcon(template.uploadedFile?.fileName || 'document')}
            <Typography sx={{ ...typography.smallText, color: grey[600], textAlign: 'center' }}>
              {template.uploadedFile?.fileType?.toUpperCase() || 'FILE'}
            </Typography>
          </Box>
        )}

        <Box
          className="preview-overlay"
          sx={{
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0,
            transition: 'opacity 0.3s ease'
          }}
        >
          <Box sx={{ textAlign: 'center', color: 'white' }}>
            <PreviewIcon sx={{ fontSize: isMobile ? 24 : 32, mb: 0.5 }} />
            <Typography sx={{ ...typography.smallText }}>Click to Preview</Typography>
          </Box>
        </Box>

        {template.uploadedFile?.fileSize && (
          <Chip
            label={`${
              template.uploadedFile.fileSize > 1024 * 1024
                ? `${(template.uploadedFile.fileSize / 1024 / 1024).toFixed(1)}MB`
                : `${(template.uploadedFile.fileSize / 1024).toFixed(0)}KB`
            }`}
            size="small"
            sx={{
              position: 'absolute',
              top: 6,
              right: 6,
              fontSize: '0.5rem',
              height: 16,
              bgcolor: 'rgba(0, 0, 0, 0.7)',
              color: 'white',
              '& .MuiChip-label': { px: 0.5 }
            }}
          />
        )}
      </Box>
    );
  };

  // Desktop category list with collapsible subcategories
  const renderDesktopCategoryList = () => (
    <Paper
      elevation={0}
      sx={{
        height: 'calc(100vh - 160px)',
        bgcolor: 'white',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1.5,
        overflow: 'hidden'
      }}
    >
      <Box sx={{ p: 1.5, pb: 1 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <CategoryIcon sx={{ color: purple[500], fontSize: 16 }} />
          <Typography
            sx={{
              ...typography.sectionTitle,
              fontWeight: 600
            }}
          >
            Categories
          </Typography>
          <Chip
            label={`${categoryData.length} Available`}
            size="small"
            sx={{
              height: 20,
              fontSize: '0.65rem',
              bgcolor: `${purple[500]}15`,
              color: purple[500]
            }}
          />
        </Stack>
      </Box>

      <Divider sx={{ mx: 1.5, opacity: 0.6 }} />

      <Box sx={{ p: 1, overflow: 'auto', height: 'calc(100% - 80px)' }}>
        <Stack spacing={0.25}>
          {categoryData.map((category) => {
            if (!category || !category.category) return null;

            const isExpanded = expandedCategories.has(category.category);
            const categoryColor = getCategoryColor(category.category);

            return (
              <Box key={category.category}>
                {/* Main Category */}
                <Card
                  sx={{
                    p: 1,
                    borderRadius: 1.5,
                    boxShadow: 1,
                    cursor: 'pointer',
                    border: `1px solid ${theme.palette.divider}`,
                    backgroundColor: 'background.paper',
                    '&:hover': {
                      boxShadow: 2,
                      backgroundColor: `${categoryColor}08`,
                      borderColor: categoryColor
                    },
                    transition: 'all 0.2s ease'
                  }}
                  onClick={() => handleCategoryToggle(category.category || '')}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: 1,
                        bgcolor: `${categoryColor}15`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: categoryColor
                      }}
                    >
                      {React.cloneElement(getCategoryIcon(category.category) as React.ReactElement<any>, {
                        style: { fontSize: 14 }
                      })}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          ...typography.bodyText,
                          fontWeight: 600,
                          lineHeight: 1.2
                        }}
                      >
                        {category.category}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        ...typography.smallText,
                        color: categoryColor,
                        bgcolor: `${categoryColor}15`,
                        px: 0.75,
                        py: 0.125,
                        borderRadius: 0.75,
                        minWidth: 16,
                        textAlign: 'center'
                      }}
                    >
                      {category.totalTemplates}
                    </Typography>
                    <IconButton size="small" sx={{ p: 0.25 }}>
                      {isExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                  </Stack>
                </Card>

                {/* Subcategories */}
                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                  <Box sx={{ ml: 2, mt: 0.5 }}>
                    <Stack spacing={0.25}>
                      {category.subcategories?.map((subcategory) => {
                        if (!subcategory || !subcategory.subcategory) return null;

                        const isSelected =
                          selectedCategory === category.category &&
                          selectedSubcategory === subcategory.subcategory;

                        return (
                          <Card
                            key={subcategory.subcategoryId}
                            sx={{
                              p: 0.75,
                              borderRadius: 1,
                              boxShadow: isSelected ? 2 : 0.5,
                              cursor: 'pointer',
                              border: isSelected
                                ? `2px solid ${green[500]}`
                                : `1px solid ${theme.palette.divider}`,
                              backgroundColor: isSelected ? `${green[500]}08` : 'background.paper',
                              '&:hover': {
                                boxShadow: 1,
                                backgroundColor: `${green[500]}08`,
                                borderColor: green[500]
                              },
                              transition: 'all 0.2s ease'
                            }}
                            onClick={() =>
                              handleSubcategorySelect(
                                category.category || '',
                                subcategory.subcategory || ''
                              )
                            }
                          >
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <Box
                                sx={{
                                  width: 4,
                                  height: 16,
                                  borderRadius: 2,
                                  bgcolor: isSelected ? green[500] : grey[300]
                                }}
                              />
                              <Typography
                                sx={{
                                  ...typography.smallText,
                                  fontWeight: isSelected ? 600 : 400,
                                  flex: 1
                                }}
                              >
                                {subcategory.subcategory}
                              </Typography>
                              <Typography
                                sx={{
                                  ...typography.smallText,
                                  color: green[600],
                                  bgcolor: `${green[500]}15`,
                                  px: 0.5,
                                  py: 0.125,
                                  borderRadius: 0.5,
                                  minWidth: 16,
                                  textAlign: 'center',
                                  fontSize: '0.6rem'
                                }}
                              >
                                {subcategory.count}
                              </Typography>
                            </Stack>
                          </Card>
                        );
                      })}
                    </Stack>
                  </Box>
                </Collapse>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Paper>
  );

  // Cleanup effect
  useEffect(() => {
    return () => {
      if (templatePreviewUrl) {
        URL.revokeObjectURL(templatePreviewUrl);
      }
      Object.values(cardPreviewUrls).forEach((url) => {
        if (url) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, []);

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
        <Stack
          direction="row"
          spacing={1.5}
          justifyContent="center"
          alignItems="center"
          sx={{ minHeight: '30vh' }}
        >
          <CircularProgress size={24} />
          <Typography sx={{ ...typography.bodyText }} color="text.secondary">
            Loading templates...
          </Typography>
        </Stack>
      </Container>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
        {/* Page Header */}
        <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
          <Typography
            sx={{
              ...typography.mainTitle,
              fontWeight: 'bold',
              color: 'primary.main',
              mb: 0.5
            }}
          >
            View Templates
          </Typography>
          <Typography
            sx={{
              ...typography.smallText,
              color: 'text.secondary'
            }}
          >
            Browse and manage document templates • {filteredTemplates.length} template
            {filteredTemplates.length !== 1 ? 's' : ''}
            {selectedCategory && ` in "${selectedCategory}"`}
            {selectedSubcategory && ` > "${selectedSubcategory}"`}
          </Typography>
        </Box>

        {error && (
          <Alert
            severity="error"
            sx={{ mb: { xs: 1.5, md: 2 }, borderRadius: 1.5 }}
            onClose={() => dispatch(clearTemplateError())}
          >
            <Typography sx={{ ...typography.smallText }}>Error: {error}</Typography>
          </Alert>
        )}

        {/* Main Content Grid */}
        <Grid container spacing={isMobile ? 1 : 1.5}>
          {!isMobile && categoryData.length > 0 && (
            <Grid item sm={3}>
              {renderDesktopCategoryList()}
            </Grid>
          )}

          <Grid item xs={12} sm={isMobile || categoryData.length === 0 ? 12 : 9}>
            <Paper
              elevation={0}
              sx={{
                p: isMobile ? 1 : 1.5,
                bgcolor: 'white',
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 1.5,
                minHeight: isMobile ? 'auto' : 'calc(100vh - 160px)'
              }}
            >
              {filteredTemplates.length > 0 ? (
                <Grid container spacing={isMobile ? 1 : 1.5}>
                  {filteredTemplates.map((template) => {
                    // Add null check for template
                    if (!template || !template.documentId) return null;

                    return (
                      <Grid item xs={12} md={6} key={template.documentId}>
                        <Card
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            p: 0,
                            borderRadius: 1.5,
                            boxShadow: 1,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            border: `1px solid ${theme.palette.divider}`,
                            backgroundColor: 'background.paper',
                            '&:hover': {
                              boxShadow: 3,
                              transform: 'translateY(-2px)',
                              borderColor: theme.palette.primary.main
                            },
                            height: isMobile ? 200 : 220,
                            position: 'relative',
                            overflow: 'hidden'
                          }}
                        >
                          {/* Action Buttons */}
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 6,
                              right: 6,
                              zIndex: 3,
                              bgcolor: 'rgba(255, 255, 255, 0.9)',
                              borderRadius: 1,
                              p: 0.25
                            }}
                          >
                            <Stack direction="row" spacing={0.25}>
                              <Tooltip title="Edit Template">
                                <IconButton
                                  onClick={(e) => handleEdit(e, template)}
                                  sx={{
                                    ...iconButtonStyles.base,
                                    ...iconButtonStyles.sizes.small,
                                    '&:hover': {
                                      bgcolor: blue[50],
                                      color: blue[600]
                                    }
                                  }}
                                >
                                  <EditIcon sx={{ fontSize: 12 }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Template">
                                <IconButton
                                  onClick={(e) => handleDelete(e, template)}
                                  sx={{
                                    ...iconButtonStyles.base,
                                    ...iconButtonStyles.sizes.small,
                                    '&:hover': {
                                      bgcolor: red[50],
                                      color: red[600]
                                    }
                                  }}
                                >
                                  <DeleteIcon sx={{ fontSize: 12 }} />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </Box>

                          <Box
                            sx={{
                              width: isMobile ? '100%' : 140,
                              height: isMobile ? 120 : '100%',
                              flexShrink: 0,
                              p: isMobile ? 1.5 : 2
                            }}
                          >
                            {renderTemplatePreview(template)}
                          </Box>

                          <CardContent
                            sx={{
                              flex: 1,
                              p: isMobile ? 1.5 : 2,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between'
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{
                                  ...typography.cardTitle,
                                  fontWeight: 600,
                                  mb: 1,
                                  lineHeight: 1.3,
                                  overflow: 'hidden',
                                  display: '-webkit-box',
                                  WebkitLineClamp: isMobile ? 3 : 2,
                                  WebkitBoxOrient: 'vertical'
                                }}
                              >
                                {template.documentName || 'Untitled Template'}
                              </Typography>

                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={0.5}
                                sx={{ mb: 0.75 }}
                              >
                                <FolderIcon sx={{ fontSize: 10, color: grey[500] }} />
                                <Typography
                                  sx={{ ...typography.smallText }}
                                  color="text.secondary"
                                  noWrap
                                >
                                  {template.uploadedFile?.fileName || 'Empty Template'}
                                </Typography>
                              </Stack>

                              {/* Display subcategory */}
                              {template.subcategory && (
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={0.5}
                                  sx={{ mb: 0.75 }}
                                >
                                  <CategoryIcon sx={{ fontSize: 10, color: green[500] }} />
                                  <Typography
                                    sx={{ ...typography.smallText }}
                                    color="text.secondary"
                                    noWrap
                                  >
                                    {template.subcategory}
                                  </Typography>
                                </Stack>
                              )}

                              <Typography sx={{ ...typography.smallText }} color="text.secondary">
                                {template.inputFields?.length || 0} field
                                {template.inputFields?.length !== 1 ? 's' : ''}
                                {template.inputFields?.some((f) => f.isRequired) &&
                                  ' • Required fields'}
                              </Typography>
                            </Box>

                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              sx={{ mt: 'auto', pt: 1 }}
                            >
                              <Stack direction="row" alignItems="center" spacing={0.5}>
                                <TimeIcon sx={{ fontSize: 10, color: grey[500] }} />
                                <Typography sx={{ ...typography.smallText }} color="text.secondary">
                                  {formatDate(template.createdDate)}
                                </Typography>
                              </Stack>
                              <Chip
                                label={`v${template.version}`}
                                size="small"
                                variant="outlined"
                                sx={{
                                  fontSize: '0.5rem',
                                  height: 16
                                }}
                              />
                            </Stack>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              ) : (
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  spacing={1.5}
                  sx={{ py: isMobile ? 3 : 6, textAlign: 'center' }}
                >
                  <Box sx={{ opacity: 0.3 }}>
                    <DocumentIcon sx={{ fontSize: isMobile ? 40 : 56, color: grey[400] }} />
                  </Box>
                  <Box>
                    <Typography
                      sx={{ ...typography.sectionTitle }}
                      color="text.secondary"
                      gutterBottom
                    >
                      No Templates Found
                    </Typography>
                    <Typography sx={{ ...typography.bodyText }} color="text.secondary">
                      {selectedSubcategory
                        ? `No templates available in "${selectedCategory} > ${selectedSubcategory}".`
                        : selectedCategory
                        ? `No templates available in the "${selectedCategory}" category.`
                        : 'No templates available.'}
                    </Typography>
                  </Box>
                </Stack>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Mobile Category Menu with nested structure */}
      {isMobile && categoryData.length > 0 && (
        <>
          <Fab
            onClick={(e) => setCategoryMenuAnchor(e.currentTarget)}
            sx={{
              position: 'fixed',
              bottom: 16,
              right: 16,
              bgcolor: purple[500],
              color: 'white',
              width: 44,
              height: 44,
              '&:hover': {
                bgcolor: purple[600]
              }
            }}
          >
            <FilterIcon sx={{ fontSize: 18 }} />
          </Fab>

          <Menu
            anchorEl={categoryMenuAnchor}
            open={categoryMenuOpen}
            onClose={() => setCategoryMenuAnchor(null)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            PaperProps={{
              sx: {
                maxHeight: '60vh',
                width: '280px',
                borderRadius: 1.5
              }
            }}
          >
            <Box sx={{ p: 1.5, pb: 0.75 }}>
              <Typography sx={{ ...typography.bodyText, fontWeight: 600 }}>
                Select Category & Subcategory
              </Typography>
            </Box>
            <Divider sx={{ opacity: 0.6 }} />

            {categoryData.map((category) => {
              if (!category || !category.category) return null;

              const categoryColor = getCategoryColor(category.category);

              return (
                <Box key={category.category}>
                  {/* Category Header */}
                  <MenuItem
                    sx={{
                      py: 1,
                      bgcolor: `${categoryColor}08`,
                      '&:hover': {
                        bgcolor: `${categoryColor}15`
                      }
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%' }}>
                      <Box
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: 1,
                          bgcolor: `${categoryColor}20`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: categoryColor
                        }}
                      >
                        {React.cloneElement(getCategoryIcon(category.category) as React.ReactElement<any>, {
                          style: { fontSize: 12 }
                        })}
                      </Box>
                      <Typography
                        sx={{
                          ...typography.bodyText,
                          fontWeight: 600,
                          flex: 1
                        }}
                      >
                        {category.category}
                      </Typography>
                      <Typography
                        sx={{
                          ...typography.smallText,
                          color: categoryColor,
                          bgcolor: `${categoryColor}15`,
                          px: 0.5,
                          py: 0.125,
                          borderRadius: 0.5,
                          minWidth: 16,
                          textAlign: 'center'
                        }}
                      >
                        {category.totalTemplates}
                      </Typography>
                    </Stack>
                  </MenuItem>

                  {/* Subcategories */}
                  {category.subcategories?.map((subcategory) => {
                    if (!subcategory || !subcategory.subcategory) return null;

                    const isSelected =
                      selectedCategory === category.category &&
                      selectedSubcategory === subcategory.subcategory;

                    return (
                      <MenuItem
                        key={subcategory.subcategoryId}
                        onClick={() =>
                          handleSubcategorySelect(
                            category.category || '',
                            subcategory.subcategory || ''
                          )
                        }
                        sx={{
                          py: 0.75,
                          pl: 4,
                          bgcolor: isSelected ? `${green[500]}08` : 'transparent',
                          '&:hover': {
                            bgcolor: `${green[500]}08`
                          }
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          sx={{ width: '100%' }}
                        >
                          <Box
                            sx={{
                              width: 4,
                              height: 16,
                              borderRadius: 2,
                              bgcolor: isSelected ? green[500] : grey[300]
                            }}
                          />
                          <Typography
                            sx={{
                              ...typography.smallText,
                              fontWeight: isSelected ? 600 : 400,
                              flex: 1
                            }}
                          >
                            {subcategory.subcategory}
                          </Typography>
                          <Typography
                            sx={{
                              ...typography.smallText,
                              color: green[600],
                              bgcolor: `${green[500]}15`,
                              px: 0.5,
                              py: 0.125,
                              borderRadius: 0.5,
                              minWidth: 16,
                              textAlign: 'center',
                              fontSize: '0.6rem'
                            }}
                          >
                            {subcategory.count}
                          </Typography>
                        </Stack>
                      </MenuItem>
                    );
                  })}

                  {category !== categoryData[categoryData.length - 1] && (
                    <Divider sx={{ opacity: 0.3 }} />
                  )}
                </Box>
              );
            })}
          </Menu>
        </>
      )}

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={confirmDialogOpen}
        title={getDialogTitle()}
        message={getDialogMessage()}
        confirmButtonText={getDialogButtonText()}
        confirmButtonColor={getDialogButtonColor()}
        onConfirm={handleConfirmDelete}
        onCancel={handleCloseDeleteConfirmation}
        loading={deleteLoading}
      />

      {/* Preview Modal */}
      <Dialog
        open={previewModalOpen}
        onClose={handleClosePreview}
        maxWidth="xl"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 1.5,
            maxHeight: '95vh',
            height: isMobile ? '100vh' : '90vh',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <DialogTitle
          sx={{
            p: isMobile ? 1.5 : 2,
            pb: isMobile ? 1 : 1.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            flexShrink: 0
          }}
        >
          <Box>
            <Typography
              sx={{
                ...typography.mainTitle,
                fontWeight: 600,
                mb: 0.25
              }}
            >
              {selectedTemplate?.documentName}
            </Typography>
            <Typography sx={{ ...typography.smallText }} color="text.secondary">
              {selectedTemplate?.category}
              {selectedTemplate?.subcategory && ` > ${selectedTemplate.subcategory}`} • Created{' '}
              {selectedTemplate && formatDate(selectedTemplate.createdDate)}
            </Typography>
          </Box>
          <IconButton
            onClick={handleClosePreview}
            sx={{
              ...iconButtonStyles.base,
              ...iconButtonStyles.sizes.medium,
              bgcolor: grey[100],
              '&:hover': { bgcolor: grey[200] }
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider sx={{ opacity: 0.6, flexShrink: 0 }} />

        <DialogContent
          sx={{
            p: isMobile ? 1 : 2,
            overflow: 'auto',
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {selectedTemplate && (
            <Stack spacing={isMobile ? 1.5 : 2} sx={{ height: '100%' }}>
              {previewLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress size={24} />
                  <Typography sx={{ ml: 2 }}>Loading document...</Typography>
                </Box>
              ) : templatePreviewUrl ? (
                <Box sx={{ flex: 1, minHeight: 0 }}>
                  {selectedTemplate.uploadedFile?.fileType === 'pdf' ? (
                    renderPdfPreviewWithThumbnails()
                  ) : (
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 1.5,
                        overflow: 'auto',
                        bgcolor: grey[50],
                        height: '50vh'
                      }}
                    >
                      <Box
                        ref={pdfContainerRef}
                        sx={{
                          position: 'relative',
                          display: 'inline-block',
                          isolation: 'isolate'
                        }}
                      >
                        <img
                          src={templatePreviewUrl}
                          alt={selectedTemplate.documentName}
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                          }}
                          onLoad={() => setOverlayRenderTrigger((prev) => prev + 1)}
                        />

                        {/* Render overlays for image */}
                        {selectedTemplate?.inputFields
                          ?.filter((field: any) => field.pageNumber === 1)
                          .map((field: any) => (
                            <ViewInputFieldOverlay
                              key={field.id}
                              field={field}
                              pdfContainerRef={pdfContainerRef as React.RefObject<HTMLDivElement>}
                              handleFieldClick={handleFieldClick}
                              isMobile={isMobile}
                              isTemplateView={true}
                            />
                          ))}
                      </Box>
                    </Box>
                  )}
                </Box>
              ) : (
                // NEW: Handle empty template case
                <Box sx={{ flex: 1, minHeight: 0 }}>{renderEmptyTemplateCanvas()}</Box>
              )}

              {/* Rest of your template details... */}
            </Stack>
          )}
        </DialogContent>

        <Divider sx={{ opacity: 0.6, flexShrink: 0 }} />

        <DialogActions sx={{ p: isMobile ? 1.5 : 2, gap: 0.75, flexShrink: 0 }}>
          <Button
            onClick={handleClosePreview}
            sx={{
              ...buttonStyles.base,
              ...buttonStyles.sizes.small,
              ...buttonStyles.variants.outlined
            }}
          >
            Close
          </Button>
          <Button
            onClick={() =>
              selectedTemplate && handleEdit({ stopPropagation: () => {} } as any, selectedTemplate)
            }
            startIcon={<EditIcon />}
            sx={{
              ...buttonStyles.base,
              ...buttonStyles.sizes.small,
              ...buttonStyles.variants.contained
            }}
          >
            Edit Template
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewTemplatesListComponent;

